import React from 'react';

import { C, HL, Lbl, Div } from './svgPrimitives';



export const levelCardsVisuals = {

  l1_c1_company_raises_capital: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="35" width="50" height="28" rx="3" fill="#6366F1" />

      <text x="35" y="52" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Company</text>

      <circle cx="145" cy="40" r="9" fill="#16C784" opacity="0.8" />

      <circle cx="162" cy="52" r="9" fill="#16C784" opacity="0.8" />

      <circle cx="145" cy="64" r="9" fill="#16C784" opacity="0.8" />

      <text x="153" y="80" fill="#64748b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Investors</text>

      <line x1="134" y1="48" x2="63" y2="48" stroke="#16C784" strokeWidth="1.5" />

      <polygon points="60,48 67,44 67,52" fill="#16C784" />

      <text x="97" y="44" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">₹ Capital</text>

      <line x1="63" y1="58" x2="134" y2="58" stroke="#6366F1" strokeWidth="1.5" />

      <polygon points="137,58 130,54 130,62" fill="#6366F1" />

      <text x="97" y="68" fill="#6366F1" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Ownership %</text>

      <text x="100" y="100" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Capital in exchange for ownership</text>

    </svg>

  ),



  l1_c2_stock_market_bridge: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="8" y="38" width="45" height="28" rx="3" fill="#6366F1" />

      <text x="30" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Company</text>

      <rect x="147" y="38" width="45" height="28" rx="3" fill="#16C784" />

      <text x="169" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Investor</text>

      <line x1="53" y1="52" x2="147" y2="52" stroke="#94a3b8" strokeWidth="2" />

      <path d="M 68,52 Q 100,28 132,52" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="4,3" />

      <text x="100" y="26" fill="#f59e0b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Stock Market</text>

      <text x="100" y="100" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Market = bridge between both</text>

    </svg>

  ),



  l1_c3_share_representation: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="35" y="18" width="130" height="76" rx="4" fill="#0f172a" stroke="#6366F1" strokeWidth="1.5" />

      {[...Array(20)].map((_, i) => (

        <rect key={i} x={40 + (i % 5) * 25} y={24 + Math.floor(i / 5) * 18} width="20" height="13" rx="2"

          fill={i < 2 ? "#16C784" : "#1e3a5f"} stroke={i < 2 ? "#16C784" : "#6366F1"} strokeWidth="0.5" />

      ))}

      <text x="100" y="12" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Company split into 1,000 parts</text>

      <text x="57" y="105" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">You own 2</text>

      <text x="140" y="105" fill="#64748b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">= 0.2% ownership</text>

    </svg>

  ),



  l1_c4_buy_low_sell_high: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="15,88 48,72 88,50 128,28" fill="none" stroke="#16C784" strokeWidth="2" />

      <polyline points="128,28 170,40" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeDasharray="4,3" />

      <circle cx="48" cy="72" r="5" fill="#16C784" />

      <text x="48" y="86" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Buy ₹100</text>

      <circle cx="128" cy="28" r="5" fill="#ef4444" />

      <text x="128" y="22" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Sell ₹130</text>

      <text x="88" y="50" fill="#f59e0b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">+₹30</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Buy low, sell higher = profit</text>

    </svg>

  ),



  l1_c5_trade_matching: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="4" y="33" width="42" height="28" rx="3" fill="#16C784" opacity="0.15" stroke="#16C784" strokeWidth="1.5" />

      <text x="25" y="48" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Buyer</text>

      <text x="25" y="58" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">₹100</text>

      <rect x="154" y="33" width="42" height="28" rx="3" fill="#ef4444" opacity="0.15" stroke="#ef4444" strokeWidth="1.5" />

      <text x="175" y="48" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Seller</text>

      <text x="175" y="58" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">₹100</text>

      <rect x="72" y="28" width="56" height="38" rx="4" fill="#1e293b" stroke="#f59e0b" strokeWidth="1.5" />

      <text x="100" y="44" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">NSE/BSE</text>

      <text x="100" y="56" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Exchange</text>

      <line x1="46" y1="47" x2="72" y2="47" stroke="#16C784" strokeWidth="1.5" />

      <polygon points="72,47 66,44 66,50" fill="#16C784" />

      <line x1="154" y1="47" x2="128" y2="47" stroke="#ef4444" strokeWidth="1.5" />

      <polygon points="128,47 134,44 134,50" fill="#ef4444" />

      <text x="100" y="82" fill="#f59e0b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">OK MATCHED</text>

      <text x="100" y="103" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Exchange matches every buyer to a seller</text>

    </svg>

  ),



  l1_c6_price_demand_supply: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="18" width="88" height="75" rx="4" fill="#0f172a" stroke="#334155" strokeWidth="1" />

      <text x="49" y="30" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">More Buyers</text>

      <rect x="14" y="48" width="14" height="38" fill="#16C784" opacity="0.7" rx="1" />

      <rect x="32" y="40" width="14" height="46" fill="#16C784" opacity="0.85" rx="1" />

      <rect x="50" y="32" width="14" height="54" fill="#16C784" rx="1" />

      <text x="76" y="55" fill="#16C784" fontSize="16" textAnchor="middle" fontFamily="sans-serif">^</text>

      <rect x="107" y="18" width="88" height="75" rx="4" fill="#0f172a" stroke="#334155" strokeWidth="1" />

      <text x="151" y="30" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">More Sellers</text>

      <rect x="116" y="32" width="14" height="54" fill="#ef4444" rx="1" />

      <rect x="134" y="40" width="14" height="46" fill="#ef4444" opacity="0.85" rx="1" />

      <rect x="152" y="48" width="14" height="38" fill="#ef4444" opacity="0.7" rx="1" />

      <text x="178" y="55" fill="#ef4444" fontSize="16" textAnchor="middle" fontFamily="sans-serif">v</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Demand vs supply drives every price move</text>

    </svg>

  ),



  l1_c7_market_participants: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="13" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Retail Trader</text>

      <circle cx="50" cy="32" r="10" fill="#6366F1" opacity="0.7" />

      <text x="50" y="35" fill="#fff" fontSize="7" textAnchor="middle" fontFamily="sans-serif">10</text>

      <text x="50" y="49" fill="#6366F1" fontSize="7" textAnchor="middle" fontFamily="sans-serif">shares</text>

      <text x="50" y="65" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Small impact</text>

      <text x="50" y="76" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">on price</text>

      <text x="150" y="13" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Institution / Fund</text>

      <rect x="115" y="20" width="70" height="38" rx="4" fill="#f59e0b" opacity="0.15" stroke="#f59e0b" strokeWidth="1.5" />

      <text x="150" y="36" fill="#f59e0b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">1,00,000</text>

      <text x="150" y="48" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">shares</text>

      <text x="150" y="65" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Moves the</text>

      <text x="150" y="76" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">price</text>

      <text x="100" y="100" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Big players create trends you can follow</text>

    </svg>

  ),



  l1_c8_candlestick_chart: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={80} o={82} c={25} h={12} l={96} w={36} />

      <line x1="58" y1="12" x2="80" y2="12" stroke="#94a3b8" strokeWidth="1" strokeDasharray="3,2" />

      <text x="56" y="15" fill="#94a3b8" fontSize="8" textAnchor="end" fontFamily="sans-serif">H</text>

      <line x1="58" y1="25" x2="80" y2="25" stroke="#16C784" strokeWidth="1" strokeDasharray="3,2" />

      <text x="56" y="28" fill="#16C784" fontSize="8" textAnchor="end" fontFamily="sans-serif">C</text>

      <line x1="58" y1="82" x2="80" y2="82" stroke="#16C784" strokeWidth="1" strokeDasharray="3,2" />

      <text x="56" y="85" fill="#16C784" fontSize="8" textAnchor="end" fontFamily="sans-serif">O</text>

      <line x1="58" y1="96" x2="80" y2="96" stroke="#94a3b8" strokeWidth="1" strokeDasharray="3,2" />

      <text x="56" y="99" fill="#94a3b8" fontSize="8" textAnchor="end" fontFamily="sans-serif">L</text>

      <text x="152" y="30" fill="#94a3b8" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">H = Highest point</text>

      <text x="152" y="44" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">C = Where it closed</text>

      <text x="152" y="58" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">O = Where it opened</text>

      <text x="152" y="72" fill="#94a3b8" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">L = Lowest point</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">One candle = one full period story</text>

    </svg>

  ),



  l1_c9_chart_patterns: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="10" y1="42" x2="190" y2="42" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="185" y="38" fill="#f59e0b" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Resistance</text>

      <C x={10} o={72} c={54} h={48} l={74} w={11} />

      <C x={24} o={54} c={60} h={44} l={62} w={11} />

      <C x={38} o={60} c={52} h={48} l={63} w={11} />

      <C x={52} o={52} c={57} h={43} l={60} w={11} />

      <C x={66} o={57} c={51} h={44} l={59} w={11} />

      <C x={80} o={51} c={55} h={43} l={57} w={11} />

      <C x={94} o={72} c={20} h={16} l={74} w={13} />

      <C x={110} o={38} c={14} h={12} l={40} w={11} />

      <C x={124} o={22} c={10} h={8} l={24} w={11} />

      <polygon points="100,28 97,22 103,22" fill="#16C784" />

      <text x="160" y="25" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Breakout!</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Patterns repeat  -  human behavior repeats</text>

    </svg>

  ),



  l1_c10_technical_indicators: (

    <svg viewBox="0 0 200 110" className="w-full">

      <path d="M 38,80 A 62,62 0 0,1 162,80" fill="none" stroke="#1e293b" strokeWidth="12" strokeLinecap="round" />

      <path d="M 38,80 A 62,62 0 0,1 100,18" fill="none" stroke="#16C784" strokeWidth="10" strokeLinecap="round" opacity="0.5" />

      <path d="M 100,18 A 62,62 0 0,1 162,80" fill="none" stroke="#ef4444" strokeWidth="10" strokeLinecap="round" opacity="0.5" />

      <line x1="100" y1="80" x2="138" y2="36" stroke="#f59e0b" strokeWidth="2.5" strokeLinecap="round" />

      <circle cx="100" cy="80" r="5" fill="#f59e0b" />

      <text x="28" y="96" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Low</text>

      <text x="100" y="16" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Mid</text>

      <text x="172" y="96" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">High</text>

      <text x="100" y="104" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Indicators confirm  -  they don't predict</text>

    </svg>

  ),



  l1_c11_trading_vs_investing: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="12" fill="#6366F1" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Trading</text>

      <C x={8}  o={70} c={48} h={44} l={73} w={14} />

      <C x={25} o={48} c={75} h={42} l={77} w={14} />

      <C x={42} o={75} c={52} h={48} l={78} w={14} />

      <C x={59} o={52} c={72} h={46} l={75} w={14} />

      <text x="50" y="98" fill="#6366F1" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Hours / Days</text>

      <text x="150" y="12" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Investing</text>

      <polyline points="108,87 128,70 148,53 168,34 183,20" fill="none" stroke="#16C784" strokeWidth="2.5" />

      <circle cx="108" cy="87" r="3" fill="#16C784" />

      <circle cx="183" cy="20" r="3" fill="#16C784" />

      <text x="150" y="98" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Months / Years</text>

    </svg>

  ),



  l1_c12_futures_options: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="62" y="12" width="76" height="42" rx="4" fill="#1e293b" stroke="#f59e0b" strokeWidth="1.5" />

      <text x="100" y="27" fill="#f59e0b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">CONTRACT</text>

      <text x="100" y="38" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">F = must buy/sell</text>

      <text x="100" y="48" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">O = right, not obligation</text>

      <text x="28" y="72" fill="#64748b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">₹10K</text>

      <text x="28" y="82" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">margin</text>

      <line x1="48" y1="74" x2="68" y2="74" stroke="#94a3b8" strokeWidth="1.5" />

      <polygon points="68,74 62,71 62,77" fill="#94a3b8" />

      <text x="100" y="72" fill="#f59e0b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Controls</text>

      <line x1="132" y1="74" x2="152" y2="74" stroke="#94a3b8" strokeWidth="1.5" />

      <polygon points="152,74 146,71 146,77" fill="#94a3b8" />

      <text x="174" y="72" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">₹1L</text>

      <text x="174" y="82" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">exposure</text>

      <text x="100" y="102" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Leverage = bigger gains AND bigger losses</text>

    </svg>

  ),



  l1_c13_why_traders_lose: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="15,28 45,36 75,50 105,65 140,82" fill="none" stroke="#ef4444" strokeWidth="2" />

      <line x1="15" y1="53" x2="185" y2="53" stroke="#16C784" strokeWidth="1.5" strokeDasharray="4,3" />

      <text x="185" y="50" fill="#16C784" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Plan: exit here</text>

      <circle cx="140" cy="82" r="5" fill="#ef4444" />

      <line x1="140" y1="53" x2="140" y2="80" stroke="#ef4444" strokeWidth="1" strokeDasharray="3,2" />

      <text x="168" y="62" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">↕ extra</text>

      <text x="168" y="72" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">₹400 loss</text>

      <text x="140" y="94" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Actual exit</text>

      <text x="55" y="94" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Hope / Fear</text>

      <text x="100" y="107" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Not following the plan is the real mistake</text>

    </svg>

  ),



  l2_c201_why_traders_lose: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="35" width="180" height="40" fill="#ef4444" opacity="0.2" />

      <text x="100" y="50" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Big Loss</text>

      <text x="100" y="65" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Small Risk</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Large losses create emotional pressure</text>

    </svg>

  ),



  l2_c202_risk_profile: (

    <svg viewBox="0 0 200 110" className="w-full">

      <circle cx="60" cy="55" r="20" fill="#16C784" opacity="0.8" />

      <text x="60" y="60" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">₹5,000</text>

      <circle cx="140" cy="55" r="20" fill="#ef4444" opacity="0.8" />

      <text x="140" y="60" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">₹1,000</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Risk tolerance is personal</text>

    </svg>

  ),



  l2_c203_risk_emotional_trading: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="35" width="80" height="40" fill="#16C784" opacity="0.8" />

      <text x="50" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Comfort</text>

      <rect x="110" y="35" width="80" height="40" fill="#ef4444" opacity="0.8" />

      <text x="150" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Risk</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Mismatch causes emotional exits</text>

    </svg>

  ),



  l2_c204_capital_allocation: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="30" width="120" height="40" fill="#16C784" opacity="0.8" rx="3" />
      <text x="70" y="47" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">Savings (75%)</text>
      <text x="70" y="60" fill="#ffffff" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Protected — never risk this</text>

      <rect x="138" y="30" width="52" height="40" fill="#f59e0b" opacity="0.8" rx="3" />
      <text x="164" y="47" fill="#ffffff" fontSize="7" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">Trading</text>
      <text x="164" y="60" fill="#ffffff" fontSize="7" textAnchor="middle" fontFamily="sans-serif">(25%)</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Keep savings larger — only trade a small portion</text>

    </svg>

  ),



  l2_c205_trade_small: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="35" width="60" height="40" fill="#16C784" opacity="0.8" />

      <text x="40" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Small</text>

      <rect x="80" y="35" width="110" height="40" fill="#ef4444" opacity="0.8" />

      <text x="135" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Large</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Start small, scale later</text>

    </svg>

  ),



  l2_c206_per_trade_risk: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="35" width="80" height="40" fill="#16C784" opacity="0.8" />

      <text x="50" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">₹1,000</text>

      <rect x="110" y="35" width="80" height="40" fill="#ef4444" opacity="0.8" />

      <text x="150" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">₹5,000</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Define max loss before entering</text>

    </svg>

  ),



  l2_c207_small_losses: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="35" width="80" height="40" fill="#16C784" opacity="0.8" />

      <text x="50" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Small</text>

      <rect x="110" y="35" width="80" height="40" fill="#ef4444" opacity="0.8" />

      <text x="150" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Big</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Small losses keep you in the game</text>

    </svg>

  ),



  l2_c208_risk_reward_ratio: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="35" width="60" height="40" fill="#16C784" opacity="0.8" />

      <text x="40" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Risk</text>

      <rect x="80" y="35" width="110" height="40" fill="#6366F1" opacity="0.8" />

      <text x="135" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Reward</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Good trades have better reward than risk</text>

    </svg>

  ),



  l2_c209_risk_reward_important: (

    <svg viewBox="0 0 200 110" className="w-full">

      <text x="100" y="15" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Per trade: each win is bigger than each loss</text>

      <rect x="10" y="25" width="40" height="30" fill="#ef4444" opacity="0.8" rx="2" />
      <text x="30" y="37" fill="#ffffff" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Loss</text>
      <text x="30" y="48" fill="#ffffff" fontSize="7" textAnchor="middle" fontFamily="sans-serif">₹500</text>

      <rect x="60" y="25" width="130" height="30" fill="#16C784" opacity="0.8" rx="2" />
      <text x="125" y="37" fill="#ffffff" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Win</text>
      <text x="125" y="48" fill="#ffffff" fontSize="7" textAnchor="middle" fontFamily="sans-serif">₹1,500</text>

      <text x="100" y="75" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">3 losses (₹1,500) = 1 win (₹1,500) → still break even</text>
      <text x="100" y="88" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Win 25% of trades and still be profitable</text>

    </svg>

  ),



  l2_c210_risk_capital: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="35" width="80" height="40" fill="#16C784" opacity="0.8" />

      <text x="50" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">₹40,000</text>

      <rect x="110" y="35" width="80" height="40" fill="#f59e0b" opacity="0.8" />

      <text x="150" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">₹800</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Risk % x capital = max loss</text>

    </svg>

  ),



  l2_c211_overtrading: (

    <svg viewBox="0 0 200 110" className="w-full">

      <text x="100" y="12" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Morning: 3 good trades (profit). Afternoon: tired, 5 weak trades (loss)</text>

      <rect x="10" y="20" width="12" height="30" fill="#16C784" opacity="0.8" rx="1" />
      <rect x="26" y="28" width="12" height="22" fill="#16C784" opacity="0.8" rx="1" />
      <rect x="42" y="24" width="12" height="26" fill="#16C784" opacity="0.8" rx="1" />

      <line x1="62" y1="15" x2="62" y2="105" stroke="#334155" strokeWidth="1" strokeDasharray="3,3" />
      <text x="62" y="13" fill="#f59e0b" fontSize="6" textAnchor="middle" fontFamily="sans-serif">tired</text>

      <rect x="66" y="38" width="10" height="12" fill="#ef4444" opacity="0.8" rx="1" />
      <rect x="80" y="42" width="10" height="16" fill="#ef4444" opacity="0.8" rx="1" />
      <rect x="94" y="40" width="10" height="20" fill="#ef4444" opacity="0.8" rx="1" />
      <rect x="108" y="38" width="10" height="22" fill="#ef4444" opacity="0.8" rx="1" />
      <rect x="122" y="35" width="10" height="28" fill="#ef4444" opacity="0.8" rx="1" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">More trades ≠ more profit. Stop when quality drops.</text>

    </svg>

  ),



  l2_c212_increase_capital: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="35" width="80" height="40" fill="#16C784" opacity="0.8" />

      <text x="50" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">3 months</text>

      <rect x="110" y="35" width="80" height="40" fill="#f59e0b" opacity="0.8" />

      <text x="150" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">1 week</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Scale only after consistent profit</text>

    </svg>

  ),



  l2_c213_protect_then_grow: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="35" width="80" height="40" fill="#16C784" opacity="0.8" />

      <text x="50" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Protect</text>

      <rect x="110" y="35" width="80" height="40" fill="#6366F1" opacity="0.8" />

      <text x="150" y="55" fill="#ffffff" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Grow</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Survival is the first goal</text>

    </svg>

  ),



  ai_probability_insights: (

    <svg viewBox="0 0 200 110" className="w-full">

      <text x="100" y="20" fill="#64748b" fontSize="10" textAnchor="middle" fontFamily="sans-serif">

        AI != Certainty

      </text>

      <text x="100" y="40" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">

        "Possible breakout forming"

      </text>

      <text x="100" y="60" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">

        "Not guaranteed"

      </text>

    </svg>

  ),



  ai_suggestion_validation: (

    <svg viewBox="0 0 200 110" className="w-full">

      <text x="100" y="20" fill="#64748b" fontSize="10" textAnchor="middle" fontFamily="sans-serif">

        Validate AI Suggestions

      </text>

      <text x="100" y="50" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">

        Resistance at ₹255

      </text>

      <text x="100" y="70" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">

        Weak Volume

      </text>

    </svg>

  ),



  ai_trade_idea_flow: (

    <svg viewBox="0 0 200 110" className="w-full">

      <text x="100" y="20" fill="#64748b" fontSize="10" textAnchor="middle" fontFamily="sans-serif">

        AI Trade Idea

      </text>

      <text x="100" y="50" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">

        Trend + Momentum

      </text>

      <text x="100" y="70" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">

        Volume + Structure

      </text>

    </svg>

  ),



  ai_edge_validation: (

    <svg viewBox="0 0 200 110" className="w-full">

      <text x="100" y="20" fill="#64748b" fontSize="10" textAnchor="middle" fontFamily="sans-serif">

        AI + Understanding

      </text>

      <text x="100" y="50" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">

        Validated Trade

      </text>

      <text x="100" y="80" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">

        Blind Trade

      </text>

    </svg>

  ),



  ai_wrong_prediction: (

    <svg viewBox="0 0 200 110" className="w-full">

      <text x="100" y="20" fill="#64748b" fontSize="10" textAnchor="middle" fontFamily="sans-serif">

        AI Prediction Error

      </text>

      <text x="100" y="50" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">

        News Impact

      </text>

      <text x="100" y="70" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">

        Sudden Selling

      </text>

    </svg>

  ),



  l4_c401: (

    <svg viewBox="0 0 200 110" className="w-full">

      <text x="100" y="12" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI drops below 30 — "must reverse now"</text>

      <C x={20} o={38} c={52} h={36} l={54} w={12} />
      <C x={35} o={52} c={64} h={50} l={66} w={12} />
      <C x={50} o={64} c={75} h={72} l={77} w={12} />
      <C x={65} o={75} c={85} h={82} l={87} w={12} />
      <C x={80} o={85} c={93} h={91} l={95} w={12} />

      <text x="125" y="36" fill="#f59e0b" fontSize="7" textAnchor="start" fontFamily="sans-serif">RSI = 28</text>
      <text x="125" y="48" fill="#f59e0b" fontSize="7" textAnchor="start" fontFamily="sans-serif">↓ still falling</text>
      <text x="125" y="60" fill="#f59e0b" fontSize="7" textAnchor="start" fontFamily="sans-serif">RSI = 18</text>
      <text x="125" y="72" fill="#f59e0b" fontSize="7" textAnchor="start" fontFamily="sans-serif">↓ still falling</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Indicators describe the past — they don't predict</text>

    </svg>

  ),

  l4_c402: (

    <svg viewBox="0 0 200 110" className="w-full">

      <text x="100" y="12" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Adding more tools creates confusion, not clarity</text>

      <rect x="5"   y="20" width="36" height="18" rx="2" fill="#1e293b" stroke="#6366F1" strokeWidth="1" />
      <text x="23"  y="32" fill="#6366F1" fontSize="6" textAnchor="middle" fontFamily="sans-serif">RSI</text>

      <rect x="45"  y="20" width="36" height="18" rx="2" fill="#1e293b" stroke="#f59e0b" strokeWidth="1" />
      <text x="63"  y="32" fill="#f59e0b" fontSize="6" textAnchor="middle" fontFamily="sans-serif">MACD</text>

      <rect x="85"  y="20" width="36" height="18" rx="2" fill="#1e293b" stroke="#ef4444" strokeWidth="1" />
      <text x="103" y="32" fill="#ef4444" fontSize="6" textAnchor="middle" fontFamily="sans-serif">BB</text>

      <rect x="125" y="20" width="36" height="18" rx="2" fill="#1e293b" stroke="#ec4899" strokeWidth="1" />
      <text x="143" y="32" fill="#ec4899" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Stoch</text>

      <text x="100" y="55" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">RSI: Buy  ·  MACD: Sell</text>
      <text x="100" y="67" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">BB: Wait  ·  Stoch: Buy</text>
      <text x="100" y="82" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Result: paralysis — miss the move</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">1–2 aligned signals beat 4 conflicting ones</text>

    </svg>

  ),

  l5_c501_trend_following: (

    <svg viewBox="0 0 200 110" className="w-full">

      <text x="100" y="20" fill="#16C784" fontSize="10" textAnchor="middle" fontFamily="sans-serif">

        Trend Following

      </text>

      <text x="100" y="50" fill="#64748b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">

        Trade with the trend

      </text>

      <text x="100" y="80" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">

        Avoid counter-trend trades

      </text>

    </svg>

  ),

  l6_c601_candle_battle: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={20} o={66} c={40} h={12} l={90} w={28} />

      <line x1="34" y1="12" x2="78" y2="12" stroke="#94a3b8" strokeWidth="1" strokeDasharray="2,2" />
      <text x="81" y="15" fill="#16C784" fontSize="7" fontFamily="sans-serif">Buyers pushed high</text>

      <line x1="34" y1="40" x2="78" y2="40" stroke="#94a3b8" strokeWidth="1" strokeDasharray="2,2" />
      <text x="81" y="43" fill="#16C784" fontSize="7" fontFamily="sans-serif">Close — buyers won</text>

      <line x1="34" y1="66" x2="78" y2="66" stroke="#94a3b8" strokeWidth="1" strokeDasharray="2,2" />
      <text x="81" y="69" fill="#94a3b8" fontSize="7" fontFamily="sans-serif">Open — battle began</text>

      <line x1="34" y1="90" x2="78" y2="90" stroke="#94a3b8" strokeWidth="1" strokeDasharray="2,2" />
      <text x="81" y="93" fill="#ef4444" fontSize="7" fontFamily="sans-serif">Sellers pushed low</text>

      <text x="100" y="108" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">One candle = one complete battle</text>

    </svg>

  ),

  l7_c701_trend_first: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,90 35,75 55,62 80,48 100,35 120,20" fill="none" stroke="#16C784" strokeWidth="1.5" strokeDasharray="4,2" />

      <C x={8}  o={88} c={74} h={70} l={90} w={14} />
      <C x={25} o={74} c={60} h={56} l={76} w={14} />
      <C x={42} o={60} c={46} h={42} l={62} w={14} />
      <C x={59} o={46} c={32} h={28} l={48} w={14} />
      <C x={76} o={32} c={18} h={14} l={34} w={14} />

      <text x="50" y="12" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">HH + HL = uptrend</text>

      <line x1="110" y1="5" x2="110" y2="105" stroke="#334155" strokeWidth="1" strokeDasharray="3,3" />

      <C x={115} o={58} c={72} h={68} l={74} w={14} />
      <text x="122" y="88" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Short against trend</text>

      <polyline points="122,70 150,75 180,82" fill="none" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="3,2" />
      <text x="170" y="72" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Stopped out</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Know the trend first — then decide</text>

    </svg>

  ),

  l9_c901_scanner_tool: (
    <svg viewBox="0 0 200 110" className="w-full">
      <text x="22" y="11" fill="#64748b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">All stocks</text>
      {[15,21,27,33,39,45,51,57,63,69,75,81,87].map((y,i) => (
        <line key={i} x1="5" y1={y} x2="42" y2={y} stroke="#334155" strokeWidth="1" opacity="0.6" />
      ))}
      <polygon points="52,52 65,46 65,58" fill="#6366F1" />
      <text x="58" y="42" fill="#6366F1" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">SCAN</text>
      <rect x="72" y="22" width="50" height="9" rx="2" fill="#16C784" opacity="0.75" />
      <rect x="72" y="38" width="50" height="9" rx="2" fill="#16C784" opacity="0.75" />
      <rect x="72" y="54" width="50" height="9" rx="2" fill="#16C784" opacity="0.75" />
      <text x="97" y="29" fill="#fff" fontSize="6" textAnchor="middle" fontFamily="sans-serif">RSI crossed 30</text>
      <text x="97" y="45" fill="#fff" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Breakout signal</text>
      <text x="97" y="61" fill="#fff" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Volume spike</text>
      <text x="97" y="79" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">→ Now check the chart</text>
      <text x="97" y="89" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Not "buy" — just "look here"</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Scanner = attention tool, not decision tool</text>
    </svg>
  ),

  l9_c902_signal_vs_trade: (
    <svg viewBox="0 0 200 110" className="w-full">
      <text x="48" y="11" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">SIGNAL</text>
      <rect x="5" y="15" width="86" height="80" rx="4" fill="#16C784" opacity="0.08" stroke="#16C784" strokeWidth="1" />
      <text x="48" y="30" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI &lt; 30</text>
      <text x="48" y="43" fill="#16C784" fontSize="18" textAnchor="middle" fontFamily="sans-serif">✓</text>
      <text x="48" y="75" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Condition met</text>
      <text x="48" y="86" fill="#64748b" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Scanner fires</text>
      <line x1="100" y1="5" x2="100" y2="105" stroke="#334155" strokeWidth="1" strokeDasharray="3,3" />
      <text x="150" y="11" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">TRADE NEEDS</text>
      <rect x="103" y="15" width="92" height="80" rx="4" fill="#ef4444" opacity="0.06" stroke="#ef4444" strokeWidth="1" />
      <text x="149" y="31" fill="#ef4444" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">✗ Chart structure</text>
      <text x="149" y="44" fill="#ef4444" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">✗ Support zone</text>
      <text x="149" y="57" fill="#ef4444" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">✗ Reversal candle</text>
      <text x="149" y="70" fill="#ef4444" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">✗ Risk plan</text>
      <text x="149" y="86" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Incomplete</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Signal alone is never enough to enter</text>
    </svg>
  ),

  l9_c903_rsi_index: (
    <svg viewBox="0 0 200 110" className="w-full">
      <text x="100" y="12" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI Scale  0 → 100</text>
      <rect x="10" y="20" width="180" height="14" rx="3" fill="#1e293b" />
      <rect x="10" y="20" width="54" height="14" rx="3" fill="#16C784" opacity="0.35" />
      <rect x="136" y="20" width="54" height="14" rx="3" fill="#ef4444" opacity="0.35" />
      <text x="37" y="30" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">0 – 30</text>
      <text x="100" y="30" fill="#64748b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">30 – 70</text>
      <text x="163" y="30" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">70 – 100</text>
      <polygon points="37,36 33,44 41,44" fill="#16C784" />
      <text x="37" y="53" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Oversold</text>
      <text x="37" y="63" fill="#16C784" fontSize="6" textAnchor="middle" fontFamily="sans-serif">strong selling</text>
      <text x="100" y="53" fill="#64748b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Neutral</text>
      <text x="100" y="63" fill="#64748b" fontSize="6" textAnchor="middle" fontFamily="sans-serif">no edge</text>
      <polygon points="163,36 159,44 167,44" fill="#ef4444" />
      <text x="163" y="53" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Overbought</text>
      <text x="163" y="63" fill="#ef4444" fontSize="6" textAnchor="middle" fontFamily="sans-serif">strong buying</text>
      <text x="100" y="82" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI = past speed, not future direction</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI tells you HOW aggressively price moved</text>
    </svg>
  ),

  l9_c904_rsi_oversold: (
    <svg viewBox="0 0 200 110" className="w-full">
      <C x={8}  o={20} c={32} h={18} l={34} w={12} />
      <C x={24} o={32} c={44} h={30} l={46} w={12} />
      <C x={40} o={44} c={56} h={42} l={58} w={12} />
      <C x={56} o={56} c={68} h={54} l={70} w={12} />
      <C x={72} o={68} c={80} h={66} l={82} w={12} />
      <polygon points="88,90 95,82 102,90" fill="#ef4444" />
      <text x="95" y="100" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">still falling</text>
      <line x1="108" y1="5" x2="108" y2="75" stroke="#334155" strokeWidth="1" strokeDasharray="3,3" />
      <text x="155" y="14" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">RSI gauge</text>
      <rect x="120" y="18" width="70" height="10" rx="2" fill="#1e293b" />
      <rect x="120" y="18" width="21" height="10" rx="2" fill="#16C784" opacity="0.5" />
      <text x="155" y="26.5" fill="#64748b" fontSize="6" textAnchor="middle" fontFamily="sans-serif">RSI = 22</text>
      <text x="155" y="42" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Oversold (&lt;30)</text>
      <text x="155" y="54" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">selling = intense</text>
      <text x="155" y="70" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">≠ instant buy</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Oversold = strong selling, not automatic bounce</text>
    </svg>
  ),

  l9_c905_rsi_overbought: (
    <svg viewBox="0 0 200 110" className="w-full">
      <C x={8}  o={82} c={70} h={68} l={84} w={12} />
      <C x={24} o={70} c={58} h={56} l={72} w={12} />
      <C x={40} o={58} c={46} h={44} l={60} w={12} />
      <C x={56} o={46} c={34} h={32} l={48} w={12} />
      <C x={72} o={34} c={22} h={20} l={36} w={12} />
      <polygon points="88,12 95,20 102,12" fill="#16C784" />
      <text x="95" y="32" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">still rising</text>
      <line x1="108" y1="5" x2="108" y2="75" stroke="#334155" strokeWidth="1" strokeDasharray="3,3" />
      <text x="155" y="14" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">RSI gauge</text>
      <rect x="120" y="18" width="70" height="10" rx="2" fill="#1e293b" />
      <rect x="120" y="18" width="52" height="10" rx="2" fill="#ef4444" opacity="0.5" />
      <text x="155" y="26.5" fill="#64748b" fontSize="6" textAnchor="middle" fontFamily="sans-serif">RSI = 75</text>
      <text x="155" y="42" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Overbought (&gt;70)</text>
      <text x="155" y="54" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">buying = intense</text>
      <text x="155" y="70" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">trend can continue</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Overbought can stay overbought in strong trends</text>
    </svg>
  ),



  // -- Level 3: Market Language ----------------------------------------------



  l3_c301_bullish: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,90 40,75 70,58 110,38 150,20 185,10" fill="none" stroke="#16C784" strokeWidth="2.5" />

      <polygon points="185,10 178,14 180,4" fill="#16C784" />

      <text x="100" y="55" fill="#16C784" fontSize="28" textAnchor="middle" fontFamily="sans-serif" opacity="0.15">^</text>

      <text x="30" y="12" fill="#16C784" fontSize="9" textAnchor="middle" fontFamily="sans-serif">BULLISH</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Expecting price to rise  -  buying pressure dominates</text>

    </svg>

  ),



  l3_c302_bearish: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,15 40,28 70,45 110,62 150,80 185,95" fill="none" stroke="#ef4444" strokeWidth="2.5" />

      <polygon points="185,95 178,88 188,90" fill="#ef4444" />

      <text x="100" y="65" fill="#ef4444" fontSize="28" textAnchor="middle" fontFamily="sans-serif" opacity="0.15">v</text>

      <text x="30" y="12" fill="#ef4444" fontSize="9" textAnchor="middle" fontFamily="sans-serif">BEARISH</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Expecting price to fall  -  selling pressure dominates</text>

    </svg>

  ),



  l3_c303_breakout: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="55" x2="195" y2="55" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="190" y="51" fill="#f59e0b" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Resistance ₹500</text>

      <C x={8}  o={80} c={65} h={62} l={82} w={11} />

      <C x={22} o={65} c={72} h={60} l={74} w={11} />

      <C x={36} o={72} c={63} h={60} l={74} w={11} />

      <C x={50} o={63} c={70} h={58} l={72} w={11} />

      <C x={64} o={70} c={62} h={59} l={72} w={11} />

      <C x={80} o={62} c={20} h={14} l={64} w={14} />

      <C x={97} o={28} c={8}  h={5}  l={30} w={11} />

      <text x="155" y="32" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Breakout!</text>

      <polygon points="130,42 127,36 133,36" fill="#16C784" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Ceiling broken  -  resistance becomes support</text>

    </svg>

  ),



  l3_c304_pullback: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,90 45,68 80,45" fill="none" stroke="#16C784" strokeWidth="2" />

      <polyline points="80,45 110,62" fill="none" stroke="#ef4444" strokeWidth="2" strokeDasharray="4,2" />

      <polyline points="110,62 150,35 185,15" fill="none" stroke="#16C784" strokeWidth="2" />

      <circle cx="80" cy="45" r="4" fill="#16C784" />

      <circle cx="110" cy="62" r="4" fill="#f59e0b" />

      <text x="110" y="76" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Pullback</text>

      <text x="150" y="30" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Uptrend continues</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Temporary dip  -  uptrend still intact</text>

    </svg>

  ),



  l3_c305_consolidation: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="35" x2="195" y2="35" stroke="#16C784" strokeWidth="1" strokeDasharray="4,3" />

      <line x1="5" y1="65" x2="195" y2="65" stroke="#ef4444" strokeWidth="1" strokeDasharray="4,3" />

      <C x={10} o={58} c={42} h={38} l={60} w={12} />

      <C x={25} o={42} c={55} h={38} l={57} w={12} />

      <C x={40} o={55} c={44} h={40} l={57} w={12} />

      <C x={55} o={44} c={52} h={40} l={55} w={12} />

      <C x={70} o={52} c={45} h={39} l={54} w={12} />

      <C x={85} o={45} c={50} h={40} l={52} w={12} />

      <C x={100} o={50} c={43} h={38} l={52} w={12} />

      <C x={115} o={43} c={48} h={39} l={50} w={12} />

      <text x="170" y="32" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Upper</text>

      <text x="170" y="62" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Lower</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Sideways  -  resting before the next move</text>

    </svg>

  ),



  l3_c306_reversal: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,80 50,55 90,30" fill="none" stroke="#16C784" strokeWidth="2" />

      <polyline points="90,30 130,52 170,78 190,95" fill="none" stroke="#ef4444" strokeWidth="2" />

      <circle cx="90" cy="30" r="5" fill="#f59e0b" />

      <text x="90" y="24" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Top</text>

      <text x="40" y="95" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Uptrend</text>

      <text x="160" y="95" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Downtrend</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Trend genuinely changing direction</text>

    </svg>

  ),



  l3_c307_stop_loss: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="72" x2="195" y2="72" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="190" y="68" fill="#ef4444" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Stop Loss ₹92</text>

      <circle cx="60" cy="45" r="5" fill="#16C784" />

      <text x="60" y="38" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Buy ₹100</text>

      <polyline points="60,45 90,52 115,65 130,72" fill="none" stroke="#ef4444" strokeWidth="2" />

      <circle cx="130" cy="72" r="5" fill="#ef4444" />

      <text x="155" y="82" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Exit -₹8</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Set before entry  -  protects from bigger loss</text>

    </svg>

  ),



  l3_c308_risk_reward: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="75" x2="195" y2="75" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="4,3" />

      <line x1="5" y1="30" x2="195" y2="30" stroke="#16C784" strokeWidth="1.5" strokeDasharray="4,3" />

      <line x1="5" y1="55" x2="195" y2="55" stroke="#94a3b8" strokeWidth="1" strokeDasharray="3,2" />

      <circle cx="60" cy="55" r="5" fill="#f59e0b" />

      <text x="60" y="50" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Entry</text>

      <line x1="60" y1="55" x2="60" y2="75" stroke="#ef4444" strokeWidth="2" />

      <line x1="60" y1="55" x2="60" y2="30" stroke="#16C784" strokeWidth="2" />

      <text x="82" y="67" fill="#ef4444" fontSize="7" textAnchor="start" fontFamily="sans-serif">Risk ₹8</text>

      <text x="82" y="44" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">Reward ₹24</text>

      <text x="160" y="55" fill="#f59e0b" fontSize="9" textAnchor="middle" fontFamily="sans-serif">1:3</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Risk less, aim for more</text>

    </svg>

  ),



  l3_c309_signal_confirmation: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="12" fill="#94a3b8" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Signal</text>

      <text x="50" y="24" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI oversold</text>

      <C x={28} o={80} c={85} h={78} l={88} w={14} />

      <text x="50" y="70" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Wait...</text>

      <text x="150" y="12" fill="#94a3b8" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Confirmation</text>

      <text x="150" y="24" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Green candle closes</text>

      <C x={128} o={80} c={85} h={78} l={88} w={14} />

      <C x={145} o={75} c={40} h={36} l={76} w={14} />

      <polygon points="170,52 166,46 174,46" fill="#16C784" />

      <text x="170" y="65" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Enter</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Signal + confirmation = higher quality entry</text>

    </svg>

  ),



  l3_c310_false_breakout: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="45" x2="195" y2="45" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="190" y="41" fill="#f59e0b" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Resistance</text>

      <C x={10} o={68} c={55} h={52} l={70} w={11} />

      <C x={24} o={55} c={62} h={50} l={64} w={11} />

      <C x={38} o={62} c={55} h={52} l={64} w={11} />

      <C x={52} o={55} c={32} h={28} l={57} w={13} />

      <C x={68} o={30} c={50} h={46} l={52} w={13} />

      <text x="75" y="22" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Fake! Trap!</text>

      <polygon points="75,26 72,32 78,32" fill="#ef4444" />

      <C x={85} o={50} c={65} h={62} l={67} w={11} />

      <C x={99} o={65} c={72} h={70} l={74} w={11} />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Breaks out, then reverses  -  wait for confirmation</text>

    </svg>

  ),



  // -- Level 4: Unlearning Bad Habits ---------------------------------------



  l4_c403: (

    <svg viewBox="0 0 200 110" className="w-full">

      <text x="100" y="18" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">RSI = 20 -> Oversold</text>

      <C x={20} o={50} c={70} h={68} l={72} w={12} />

      <C x={35} o={70} c={78} h={76} l={80} w={12} />

      <C x={50} o={78} c={85} h={83} l={87} w={12} />

      <C x={65} o={85} c={90} h={88} l={92} w={12} />

      <C x={80} o={90} c={95} h={93} l={97} w={12} />

      <text x="115" y="40" fill="#94a3b8" fontSize="7" textAnchor="start" fontFamily="sans-serif">Still falling...</text>

      <text x="115" y="52" fill="#94a3b8" fontSize="7" textAnchor="start" fontFamily="sans-serif">RSI = 10</text>

      <text x="115" y="64" fill="#94a3b8" fontSize="7" textAnchor="start" fontFamily="sans-serif">RSI = 5</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Oversold can stay oversold  -  never buy blindly</text>

    </svg>

  ),



  l4_c404: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="45" x2="195" y2="45" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,3" />

      <C x={20} o={68} c={55} h={52} l={70} w={11} />

      <C x={34} o={55} c={62} h={50} l={64} w={11} />

      <C x={48} o={62} c={52} h={48} l={64} w={11} />

      <C x={62} o={52} c={32} h={26} l={54} w={14} />

      <C x={80} o={50} c={62} h={58} l={64} w={11} />

      <C x={94} o={62} c={70} h={67} l={72} w={11} />

      <text x="70" y="18" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Breakout -> reverses</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">60-70% of breakouts fail without volume</text>

    </svg>

  ),



  l4_c405: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,80 60,35" fill="none" stroke="#16C784" strokeWidth="2" />

      <circle cx="60" cy="35" r="5" fill="#16C784" />

      <text x="60" y="28" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">+30% before news</text>

      <polyline points="60,35 100,48 150,60" fill="none" stroke="#ef4444" strokeWidth="2" />

      <rect x="90" y="12" width="60" height="18" rx="3" fill="#1e293b" stroke="#f59e0b" strokeWidth="1" />

      <text x="120" y="24" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Good earnings!</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Buy the rumor, sell the news</text>

    </svg>

  ),



  l4_c406: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="14" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Forced Trade</text>

      <rect x="10" y="22" width="80" height="50" rx="4" fill="#ef4444" opacity="0.1" stroke="#ef4444" strokeWidth="1" />

      <text x="50" y="42" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">No setup</text>

      <text x="50" y="54" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Trade anyway</text>

      <text x="50" y="66" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">-> Loss</text>

      <text x="150" y="14" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">No Trade</text>

      <rect x="110" y="22" width="80" height="50" rx="4" fill="#16C784" opacity="0.1" stroke="#16C784" strokeWidth="1" />

      <text x="150" y="42" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">No setup</text>

      <text x="150" y="54" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Wait</text>

      <text x="150" y="66" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">-> Capital safe</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Not trading is a valid decision</text>

    </svg>

  ),



  l4_c407: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="18" width="84" height="60" rx="4" fill="#1e293b" stroke="#334155" strokeWidth="1" />

      <text x="52" y="32" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Win Rate 80%</text>

      <text x="52" y="46" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">8 wins x ₹300 = ₹2,400</text>

      <text x="52" y="58" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">2 loss x ₹2,000 = ₹4,000</text>

      <text x="52" y="72" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Net: -₹1,600</text>

      <rect x="106" y="18" width="84" height="60" rx="4" fill="#1e293b" stroke="#334155" strokeWidth="1" />

      <text x="148" y="32" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Win Rate 40%</text>

      <text x="148" y="46" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">4 wins x ₹1,500 = ₹6,000</text>

      <text x="148" y="58" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">6 loss x ₹500 = ₹3,000</text>

      <text x="148" y="72" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Net: +₹3,000</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Win rate alone means nothing without R:R</text>

    </svg>

  ),



  l4_c408: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="60" x2="195" y2="60" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="190" y="56" fill="#ef4444" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Stop Loss</text>

      <polyline points="20,30 50,38 75,52 95,60" fill="none" stroke="#ef4444" strokeWidth="2" />

      <circle cx="95" cy="60" r="5" fill="#16C784" />

      <text x="95" y="75" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Exit -₹500</text>

      <polyline points="95,60 130,75 160,90 185,100" fill="none" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="3,2" />

      <text x="160" y="88" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">-₹4,000</text>

      <text x="95" y="18" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Plan worked OK</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Stop loss saved ₹3,500  -  discipline not defeat</text>

    </svg>

  ),



  l4_c409: (

    <svg viewBox="0 0 200 110" className="w-full">

      <circle cx="50" cy="38" r="18" fill="#6366F1" opacity="0.2" stroke="#6366F1" strokeWidth="1.5" />

      <text x="50" y="34" fill="#6366F1" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Influencer</text>

      <text x="50" y="44" fill="#6366F1" fontSize="7" textAnchor="middle" fontFamily="sans-serif">exits +2%</text>

      <line x1="68" y1="38" x2="95" y2="38" stroke="#94a3b8" strokeWidth="1.5" />

      <polygon points="95,38 89,35 89,41" fill="#94a3b8" />

      <rect x="96" y="22" width="68" height="32" rx="3" fill="#1e293b" stroke="#f59e0b" strokeWidth="1" />

      <text x="130" y="34" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">You hold</text>

      <text x="130" y="46" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">-8% loss</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Their trade, their rules  -  not yours</text>

    </svg>

  ),



  l4_c410: (

    <svg viewBox="0 0 200 110" className="w-full">

      <circle cx="100" cy="48" r="32" fill="none" stroke="#334155" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="100" y="42" fill="#ef4444" fontSize="9" textAnchor="middle" fontFamily="sans-serif">Holy Grail</text>

      <text x="100" y="55" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">doesn't exist</text>

      <line x1="75" y1="25" x2="125" y2="73" stroke="#ef4444" strokeWidth="2" opacity="0.6" />

      <line x1="125" y1="25" x2="75" y2="73" stroke="#ef4444" strokeWidth="2" opacity="0.6" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Every strategy loses  -  manage losses so wins win</text>

    </svg>

  ),



  // -- Level 5 ---------------------------------------------------------------



  l5_c502_breakout: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="48" x2="195" y2="48" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,3" />

      <C x={8}  o={72} c={58} h={55} l={74} w={11} />

      <C x={22} o={58} c={65} h={52} l={67} w={11} />

      <C x={36} o={65} c={56} h={52} l={67} w={11} />

      <C x={50} o={56} c={62} h={50} l={64} w={11} />

      <C x={66} o={62} c={22} h={16} l={64} w={14} />

      <C x={83} o={30} c={8}  h={5}  l={32} w={11} />

      <rect x="110" y="8" width="80" height="28" rx="3" fill="#16C784" opacity="0.15" stroke="#16C784" strokeWidth="1" />

      <text x="150" y="20" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Volume spike</text>

      <text x="150" y="30" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">confirms breakout</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Volume confirms  -  no volume, no trust</text>

    </svg>

  ),



  l5_c503_pullback: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,88 40,70 70,50 100,32" fill="none" stroke="#16C784" strokeWidth="2" />

      <polyline points="100,32 125,48" fill="none" stroke="#ef4444" strokeWidth="2" strokeDasharray="4,2" />

      <polyline points="125,48 155,28 185,12" fill="none" stroke="#16C784" strokeWidth="2" />

      <circle cx="100" cy="32" r="4" fill="#16C784" />

      <circle cx="125" cy="48" r="4" fill="#f59e0b" />

      <text x="125" y="62" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Buy here</text>

      <polygon points="125,56 122,62 128,62" fill="#f59e0b" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Pullback = lower-risk entry in an uptrend</text>

    </svg>

  ),



  l5_c504_consolidation: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,85 40,60 65,40" fill="none" stroke="#16C784" strokeWidth="2" />

      <line x1="65" y1="30" x2="140" y2="30" stroke="#16C784" strokeWidth="1" strokeDasharray="3,2" />

      <line x1="65" y1="50" x2="140" y2="50" stroke="#ef4444" strokeWidth="1" strokeDasharray="3,2" />

      <C x={67}  o={46} c={34} h={32} l={48} w={10} />

      <C x={80}  o={34} c={44} h={31} l={46} w={10} />

      <C x={93}  o={44} c={36} h={32} l={46} w={10} />

      <C x={106} o={36} c={42} h={32} l={44} w={10} />

      <C x={119} o={42} c={35} h={31} l={44} w={10} />

      <polyline points="140,40 170,20 190,8" fill="none" stroke="#16C784" strokeWidth="2" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Resting zone  -  energy building for next move</text>

    </svg>

  ),



  l5_c505_reversal: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,85 50,58 95,28" fill="none" stroke="#16C784" strokeWidth="2" />

      <C x={85} o={32} c={48} h={26} l={52} w={16} />

      <C x={104} o={50} c={68} h={46} l={72} w={14} />

      <polyline points="118,65 150,78 185,95" fill="none" stroke="#ef4444" strokeWidth="2" />

      <text x="95" y="20" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Lower highs start</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Lower highs + lower lows = reversal confirmed</text>

    </svg>

  ),



  l5_c506_stop_loss: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="68" x2="195" y2="68" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="5" y="64" fill="#ef4444" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">Stop Loss  -  set before trade</text>

      <line x1="5" y1="30" x2="195" y2="30" stroke="#16C784" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="5" y="26" fill="#16C784" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">Target</text>

      <circle cx="80" cy="50" r="5" fill="#f59e0b" />

      <text x="80" y="44" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Entry</text>

      <line x1="80" y1="50" x2="80" y2="68" stroke="#ef4444" strokeWidth="2" />

      <line x1="80" y1="50" x2="80" y2="30" stroke="#16C784" strokeWidth="2" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Define exit before entry  -  always</text>

    </svg>

  ),



  l5_c507_risk_reward: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="55" width="40" height="35" rx="2" fill="#ef4444" opacity="0.7" />

      <text x="30" y="76" fill="#fff" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Risk</text>

      <text x="30" y="86" fill="#fff" fontSize="7" textAnchor="middle" fontFamily="sans-serif">₹500</text>

      <rect x="60" y="20" width="40" height="70" rx="2" fill="#16C784" opacity="0.7" />

      <text x="80" y="58" fill="#fff" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Reward</text>

      <text x="80" y="68" fill="#fff" fontSize="7" textAnchor="middle" fontFamily="sans-serif">₹1,500</text>

      <text x="160" y="45" fill="#f59e0b" fontSize="22" textAnchor="middle" fontFamily="sans-serif">1:3</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Small risk, larger reward = edge over time</text>

    </svg>

  ),



  l5_c508_signal_confirmation: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="18" width="85" height="55" rx="4" fill="#1e293b" stroke="#334155" strokeWidth="1" />

      <text x="47" y="32" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Signal only</text>

      <text x="47" y="46" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI crosses 30</text>

      <text x="47" y="60" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Enter immediately</text>

      <text x="47" y="70" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">-> Often wrong</text>

      <rect x="110" y="18" width="85" height="55" rx="4" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="152" y="32" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Signal + Confirm</text>

      <text x="152" y="46" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI + green candle</text>

      <text x="152" y="60" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Enter after close</text>

      <text x="152" y="70" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">-> Higher quality</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">One more step  -  wait for confirmation</text>

    </svg>

  ),



  l5_c509_false_breakout: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="42" x2="195" y2="42" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,3" />

      <C x={10} o={65} c={52} h={49} l={67} w={11} />

      <C x={24} o={52} c={58} h={47} l={60} w={11} />

      <C x={38} o={58} c={50} h={46} l={60} w={11} />

      <C x={52} o={50} c={28} h={22} l={52} w={14} />

      <C x={70} o={45} c={58} h={54} l={60} w={11} />

      <C x={84} o={58} c={65} h={62} l={67} w={11} />

      <text x="62" y="14" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Trap! Falls back</text>

      <polygon points="62,17 59,23 65,23" fill="#ef4444" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Breaks above -> falls back  -  wait for retest</text>

    </svg>

  ),



  l5_c510_trend_continuation: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,88 35,72 60,55 85,38 105,28" fill="none" stroke="#16C784" strokeWidth="2" />

      <polyline points="105,28 120,38" fill="none" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="3,2" />

      <polyline points="120,38 145,22 175,10 190,5" fill="none" stroke="#16C784" strokeWidth="2" />

      <line x1="85" y1="5" x2="85" y2="105" stroke="#334155" strokeWidth="1" strokeDasharray="3,2" />

      <text x="43" y="102" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Trend</text>

      <text x="140" y="102" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Continuation</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif" opacity="0">x</text>

    </svg>

  ),



  // -- Level 5 (new)  -  Fundamentals Behind the Chart ------------------------



  l5_c501_fundamentals_matter: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="20" width="80" height="70" rx="4" fill="#1e293b" stroke="#334155" strokeWidth="1" />

      <text x="50" y="38" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Chart</text>

      <polyline points="18,80 32,62 46,70 60,48 74,54 84,36" fill="none" stroke="#6366F1" strokeWidth="1.5" />

      <rect x="110" y="20" width="80" height="70" rx="4" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="150" y="36" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Fundamentals</text>

      <text x="150" y="50" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Revenue ^</text>

      <text x="150" y="62" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Profit ^</text>

      <text x="150" y="74" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Low Debt</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Charts show what. Fundamentals explain why.</text>

    </svg>

  ),



  l5_c502_fundamentals_matter: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="8" y="14" width="56" height="26" rx="3" fill="#1e293b" stroke="#f59e0b" strokeWidth="1" />

      <text x="36" y="25" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Intraday</text>

      <text x="36" y="35" fill="#64748b" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Less relevant</text>

      <rect x="72" y="14" width="56" height="26" rx="3" fill="#1e293b" stroke="#6366F1" strokeWidth="1" />

      <text x="100" y="25" fill="#6366F1" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Swing</text>

      <text x="100" y="35" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Moderate</text>

      <rect x="136" y="14" width="56" height="26" rx="3" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="164" y="25" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Positional</text>

      <text x="164" y="35" fill="#16C784" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Most critical</text>

      <line x1="36" y1="40" x2="36" y2="58" stroke="#f59e0b" strokeWidth="1" strokeDasharray="3,2" />

      <line x1="100" y1="40" x2="100" y2="58" stroke="#6366F1" strokeWidth="1" strokeDasharray="3,2" />

      <line x1="164" y1="40" x2="164" y2="58" stroke="#16C784" strokeWidth="1" strokeDasharray="3,2" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Longer the trade, more fundamentals matter</text>

    </svg>

  ),



  l5_c503_business_worth: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="30" width="85" height="55" rx="4" fill="#1e293b" stroke="#334155" strokeWidth="1" />

      <text x="52" y="46" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Weak Business</text>

      <text x="52" y="58" fill="#64748b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Revenue falling</text>

      <text x="52" y="68" fill="#64748b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">High debt</text>

      <text x="52" y="78" fill="#ef4444" fontSize="6" textAnchor="middle" fontFamily="sans-serif">-> Avoid</text>

      <rect x="105" y="30" width="85" height="55" rx="4" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="147" y="46" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Strong Business</text>

      <text x="147" y="58" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Revenue growing</text>

      <text x="147" y="68" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Low debt</text>

      <text x="147" y="78" fill="#16C784" fontSize="6" textAnchor="middle" fontFamily="sans-serif">-> Consider</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Trade with business quality, not against it</text>

    </svg>

  ),



  l5_c504_revenue_growth: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="20" y1="85" x2="20" y2="15" stroke="#334155" strokeWidth="1" />

      <line x1="20" y1="85" x2="190" y2="85" stroke="#334155" strokeWidth="1" />

      <rect x="30" y="65" width="20" height="20" rx="2" fill="#6366F1" opacity="0.7" />

      <rect x="60" y="52" width="20" height="33" rx="2" fill="#6366F1" opacity="0.8" />

      <rect x="90" y="40" width="20" height="45" rx="2" fill="#16C784" opacity="0.8" />

      <rect x="120" y="28" width="20" height="57" rx="2" fill="#16C784" opacity="0.9" />

      <rect x="150" y="18" width="20" height="67" rx="2" fill="#16C784" />

      <text x="40" y="62" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Q1</text>

      <text x="70" y="49" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Q2</text>

      <text x="100" y="37" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Q3</text>

      <text x="130" y="25" fill="#16C784" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Q4</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Consistent revenue growth = expanding business</text>

    </svg>

  ),



  l5_c505_profit_growth: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="20" width="85" height="65" rx="4" fill="#1e293b" stroke="#ef4444" strokeWidth="1" />

      <text x="52" y="36" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Revenue ^ but...</text>

      <text x="52" y="50" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Revenue: ₹100Cr</text>

      <text x="52" y="62" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Expenses: ₹98Cr</text>

      <text x="52" y="74" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Profit: ₹2Cr - weak</text>

      <rect x="105" y="20" width="85" height="65" rx="4" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="147" y="36" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Profit growing</text>

      <text x="147" y="50" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Revenue: ₹100Cr</text>

      <text x="147" y="62" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Expenses: ₹70Cr</text>

      <text x="147" y="74" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Profit: ₹30Cr - real</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Revenue without profit is incomplete growth</text>

    </svg>

  ),



  l5_c506_cash_flow: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="70" y="15" width="60" height="30" rx="4" fill="#1e293b" stroke="#6366F1" strokeWidth="1.5" />

      <text x="100" y="28" fill="#6366F1" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Business</text>

      <text x="100" y="38" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Operations</text>

      <line x1="100" y1="45" x2="100" y2="62" stroke="#16C784" strokeWidth="2" />

      <polygon points="100,65 96,60 104,60" fill="#16C784" />

      <rect x="65" y="65" width="70" height="26" rx="4" fill="#16C784" opacity="0.2" stroke="#16C784" strokeWidth="1" />

      <text x="100" y="78" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Cash In Bank OK</text>

      <text x="100" y="88" fill="#16C784" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Positive Cash Flow</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Profit on paper != cash in hand</text>

    </svg>

  ),



  l5_c507_debt_risk: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="55" width="35" height="35" rx="2" fill="#16C784" opacity="0.8" />

      <text x="27" y="70" fill="#fff" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Low</text>

      <text x="27" y="80" fill="#fff" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Debt</text>

      <text x="27" y="90" fill="#fff" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Safe</text>

      <rect x="55" y="40" width="35" height="50" rx="2" fill="#f59e0b" opacity="0.8" />

      <text x="72" y="60" fill="#fff" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Medium</text>

      <text x="72" y="70" fill="#fff" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Debt</text>

      <text x="72" y="80" fill="#fff" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Watch</text>

      <rect x="100" y="20" width="35" height="70" rx="2" fill="#ef4444" opacity="0.8" />

      <text x="117" y="52" fill="#fff" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">High</text>

      <text x="117" y="62" fill="#fff" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Debt</text>

      <text x="117" y="72" fill="#fff" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Risky</text>

      <text x="160" y="40" fill="#ef4444" fontSize="9" textAnchor="middle" fontFamily="sans-serif">D/E</text>

      <text x="160" y="54" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Debt-to-Equity</text>

      <text x="160" y="64" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">{'< 1 = safe'}</text>

      <text x="160" y="74" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">{'> 2 = risky'}</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">High debt = danger in bad markets</text>

    </svg>

  ),



  l5_c508_key_ratios: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="14" width="58" height="32" rx="3" fill="#1e293b" stroke="#6366F1" strokeWidth="1" />

      <text x="34" y="27" fill="#6366F1" fontSize="7" textAnchor="middle" fontFamily="sans-serif">P/E Ratio</text>

      <text x="34" y="38" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Price vs Earnings</text>

      <rect x="71" y="14" width="58" height="32" rx="3" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="100" y="27" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">ROE</text>

      <text x="100" y="38" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Return on Equity</text>

      <rect x="137" y="14" width="58" height="32" rx="3" fill="#1e293b" stroke="#f59e0b" strokeWidth="1" />

      <text x="166" y="27" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">D/E Ratio</text>

      <text x="166" y="38" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Debt vs Equity</text>

      <rect x="38" y="56" width="58" height="32" rx="3" fill="#1e293b" stroke="#a78bfa" strokeWidth="1" />

      <text x="67" y="69" fill="#a78bfa" fontSize="7" textAnchor="middle" fontFamily="sans-serif">EPS</text>

      <text x="67" y="80" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Earnings/Share</text>

      <rect x="104" y="56" width="58" height="32" rx="3" fill="#1e293b" stroke="#ec4899" strokeWidth="1" />

      <text x="133" y="69" fill="#ec4899" fontSize="7" textAnchor="middle" fontFamily="sans-serif">P/B Ratio</text>

      <text x="133" y="80" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Price vs Book</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Ratios = quick health check of a business</text>

    </svg>

  ),



  l5_c509_financial_statements: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="12" width="58" height="75" rx="3" fill="#1e293b" stroke="#6366F1" strokeWidth="1" />

      <text x="34" y="26" fill="#6366F1" fontSize="7" textAnchor="middle" fontFamily="sans-serif">P&amp;L</text>

      <text x="34" y="38" fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Revenue</text>

      <text x="34" y="48" fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Expenses</text>

      <text x="34" y="58" fill="#16C784" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Net Profit</text>

      <text x="34" y="72" fill="#64748b" fontSize="5" textAnchor="middle" fontFamily="sans-serif">Is it earning?</text>

      <rect x="71" y="12" width="58" height="75" rx="3" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="100" y="26" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Balance Sheet</text>

      <text x="100" y="38" fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Assets</text>

      <text x="100" y="48" fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Liabilities</text>

      <text x="100" y="58" fill="#16C784" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Net Worth</text>

      <text x="100" y="72" fill="#64748b" fontSize="5" textAnchor="middle" fontFamily="sans-serif">Is it strong?</text>

      <rect x="137" y="12" width="58" height="75" rx="3" fill="#1e293b" stroke="#f59e0b" strokeWidth="1" />

      <text x="166" y="26" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Cash Flow</text>

      <text x="166" y="38" fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Operating CF</text>

      <text x="166" y="48" fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Investing CF</text>

      <text x="166" y="58" fill="#16C784" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Free CF</text>

      <text x="166" y="72" fill="#64748b" fontSize="5" textAnchor="middle" fontFamily="sans-serif">Is cash real?</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">3 statements = complete business picture</text>

    </svg>

  ),



  l5_c510_red_flags: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polygon points="100,8 108,28 130,28 113,40 120,62 100,50 80,62 87,40 70,28 92,28" fill="#ef4444" opacity="0.2" stroke="#ef4444" strokeWidth="1.5" />

      <text x="100" y="36" fill="#ef4444" fontSize="9" textAnchor="middle" fontFamily="sans-serif">⚠</text>

      <rect x="5" y="68" width="88" height="28" rx="3" fill="#1e293b" stroke="#ef4444" strokeWidth="1" />

      <text x="49" y="79" fill="#ef4444" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Promoter selling stake</text>

      <text x="49" y="89" fill="#ef4444" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Revenue without profit</text>

      <rect x="107" y="68" width="88" height="28" rx="3" fill="#1e293b" stroke="#ef4444" strokeWidth="1" />

      <text x="151" y="79" fill="#ef4444" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Auditor resignation</text>

      <text x="151" y="89" fill="#ef4444" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Debt rising fast</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">One red flag = investigate. Two = avoid.</text>

    </svg>

  ),



  l5_c511_fundamentals_charts: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="15" width="85" height="70" rx="4" fill="#1e293b" stroke="#6366F1" strokeWidth="1" />

      <text x="47" y="30" fill="#6366F1" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Fundamentals</text>

      <text x="47" y="42" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Strong business</text>

      <text x="47" y="52" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Good financials</text>

      <text x="47" y="62" fill="#16C784" fontSize="6" textAnchor="middle" fontFamily="sans-serif">-> Right stock</text>

      <rect x="110" y="15" width="85" height="70" rx="4" fill="#1e293b" stroke="#f59e0b" strokeWidth="1" />

      <text x="152" y="30" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Chart Setup</text>

      <text x="152" y="42" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Breakout pattern</text>

      <text x="152" y="52" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">RSI + volume</text>

      <text x="152" y="62" fill="#16C784" fontSize="6" textAnchor="middle" fontFamily="sans-serif">-> Right time</text>

      <text x="100" y="97" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Both together = high-confidence trade</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">fundamentals x chart = conviction</text>

    </svg>

  ),



  l5_c512_enter_exit: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="12" width="58" height="75" rx="3" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="34" y="26" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Enter When</text>

      <text x="34" y="38" fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Profit growing</text>

      <text x="34" y="48" fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Low debt</text>

      <text x="34" y="58" fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Breakout setup</text>

      <text x="34" y="68" fill="#16C784" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">-> Buy</text>

      <rect x="71" y="12" width="58" height="75" rx="3" fill="#1e293b" stroke="#f59e0b" strokeWidth="1" />

      <text x="100" y="26" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Avoid When</text>

      <text x="100" y="38" fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Debt rising fast</text>

      <text x="100" y="48" fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Profit falling</text>

      <text x="100" y="58" fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Red flags present</text>

      <text x="100" y="68" fill="#f59e0b" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">-> Skip</text>

      <rect x="137" y="12" width="58" height="75" rx="3" fill="#1e293b" stroke="#ef4444" strokeWidth="1" />

      <text x="166" y="26" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Exit When</text>

      <text x="166" y="38" fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Story changes</text>

      <text x="166" y="48" fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Target hit</text>

      <text x="166" y="58" fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">SL triggered</text>

      <text x="166" y="68" fill="#ef4444" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">-> Exit</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Rules-based decisions, not emotions</text>

    </svg>

  ),



  l5_c513_fundamentals_matter_duplicate: (

    <svg viewBox="0 0 200 110" className="w-full">

      <circle cx="100" cy="48" r="32" fill="#1e293b" stroke="#16C784" strokeWidth="2" />

      <text x="100" y="40" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Strong</text>

      <text x="100" y="52" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Fundamentals</text>

      <text x="100" y="62" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">= Confidence</text>

      <line x1="20" y1="85" x2="80" y2="85" stroke="#16C784" strokeWidth="1.5" />

      <text x="50" y="98" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Why to trade</text>

      <line x1="120" y1="85" x2="180" y2="85" stroke="#6366F1" strokeWidth="1.5" />

      <text x="150" y="98" fill="#6366F1" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">When to trade</text>

      <text x="100" y="107" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Fundamentals answer the why</text>

    </svg>

  ),



  l5_c514_fundamentals_matter_duplicate: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="20" y="14" width="160" height="24" rx="3" fill="#1e293b" stroke="#6366f1" strokeWidth="1" />

      <text x="100" y="22" fill="#6366f1" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Short-term trader</text>

      <text x="100" y="32" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Use fundamentals as a filter  -  avoid weak companies</text>

      <rect x="20" y="46" width="160" height="24" rx="3" fill="#1e293b" stroke="#6366F1" strokeWidth="1" />

      <text x="100" y="54" fill="#6366F1" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Swing trader</text>

      <text x="100" y="64" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Fundamentals confirm whether move can sustain</text>

      <rect x="20" y="78" width="160" height="20" rx="3" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="100" y="87" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Positional trader</text>

      <text x="100" y="96" fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Fundamentals are the core reason for the trade</text>

      <text x="100" y="107" fill="#64748b" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Match your style to your depth of research</text>

    </svg>

  ),



  // -- Level 6 ---------------------------------------------------------------



  l6_c602_body_wick: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <C x={25} o={78} c={22} h={14} l={84} w={32} />

      <line x1="68" y1="14" x2="25" y2="14" stroke="#94a3b8" strokeWidth="1" strokeDasharray="2,2" />

      <text x="20" y="12" fill="#94a3b8" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Wick</text>

      <line x1="68" y1="84" x2="25" y2="84" stroke="#94a3b8" strokeWidth="1" strokeDasharray="2,2" />

      <text x="20" y="87" fill="#94a3b8" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Wick</text>

      <text x="54" y="55" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Body</text>

      <text x="54" y="100" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Strong</text>

      <C x={130} o={50} c={44} h={8} l={96} w={24} />

      <text x="150" y="100" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Rejection</text>

      <text x="100" y="108" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Long wick = price rejected at that level</text>

    </svg>

  ),



  l6_c603_size_matters: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={8}  o={55} c={50} h={48} l={57} w={10} />

      <C x={21} o={52} c={54} h={50} l={56} w={10} />

      <C x={34} o={54} c={51} h={49} l={56} w={10} />

      <text x="26" y="105" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Small = indecision</text>

      <text x="100" y="55" fill="#94a3b8" fontSize="18" textAnchor="middle" fontFamily="sans-serif">-></text>

      <C x={128} o={88} c={14} h={8} l={92} w={38} />

      <text x="147" y="105" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Big = conviction</text>

      <text x="100" y="108" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif" opacity="0">x</text>

    </svg>

  ),



  l6_c604_speed_of_price: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="11" fill="#94a3b8" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Slow (2 days)</text>

      <C x={5}  o={84} c={80} h={78} l={86} w={9} />
      <C x={17} o={80} c={76} h={74} l={82} w={9} />
      <C x={29} o={76} c={72} h={70} l={78} w={9} />
      <C x={41} o={72} c={68} h={66} l={74} w={9} />
      <C x={53} o={68} c={64} h={62} l={70} w={9} />

      <text x="35" y="102" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Gradual — retail</text>

      <text x="155" y="11" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Fast (minutes)</text>

      <C x={115} o={84} c={22} h={16} l={88} w={30} />
      <C x={149} o={24} c={14} h={10} l={28} w={20} />

      <text x="155" y="102" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Spike — institutional</text>

      <text x="100" y="108" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Same move. Different intent.</text>

    </svg>

  ),



  l6_c605_trend_structure: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,90 40,72 60,60 90,42 115,28 140,14" fill="none" stroke="#16C784" strokeWidth="1.5" strokeDasharray="4,2" />

      <C x={8}  o={88} c={74} h={70} l={90} w={14} />

      <C x={25} o={74} c={80} h={70} l={82} w={14} />

      <C x={42} o={80} c={58} h={54} l={82} w={14} />

      <C x={59} o={58} c={65} h={54} l={67} w={14} />

      <C x={76} o={65} c={42} h={38} l={67} w={14} />

      <C x={93} o={42} c={50} h={38} l={52} w={14} />

      <C x={110} o={50} c={28} h={22} l={52} w={14} />

      <text x="160" y="20" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Higher highs</text>

      <text x="160" y="32" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Higher lows</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Uptrend = series of higher highs + higher lows</text>

    </svg>

  ),



  l6_c606_higher_highs_lower_lows: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="11" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Uptrend</text>

      <polyline points="8,88 24,70 40,78 56,55 72,62 88,40" fill="none" stroke="#16C784" strokeWidth="2" />

      <text x="20" y="68" fill="#16C784" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">HL</text>

      <text x="56" y="52" fill="#16C784" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">HH</text>

      <text x="88" y="37" fill="#16C784" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">HH</text>

      <text x="150" y="11" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Downtrend</text>

      <polyline points="108,18 124,38 140,28 156,52 172,42 188,65" fill="none" stroke="#ef4444" strokeWidth="2" />

      <text x="124" y="50" fill="#ef4444" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">LH</text>

      <text x="156" y="63" fill="#ef4444" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">LL</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">HH+HL = uptrend / LH+LL = downtrend</text>

    </svg>

  ),



  l6_c607_breakout_formation: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="44" x2="195" y2="44" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,3" />
      <text x="193" y="40" fill="#f59e0b" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Resistance</text>

      <C x={8}  o={70} c={56} h={52} l={72} w={11} />
      <C x={22} o={60} c={50} h={46} l={62} w={11} />
      <C x={36} o={56} c={48} h={44} l={58} w={11} />
      <C x={50} o={52} c={46} h={42} l={54} w={11} />

      <C x={66} o={50} c={18} h={12} l={52} w={14} />
      <text x="73" y="8" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">BREAKS OUT</text>

      <text x="30" y="96" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Each rejection</text>
      <text x="30" y="104" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">gets smaller</text>

      <text x="145" y="105" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Sellers weaken -> buyers break through</text>

    </svg>

  ),



  l6_c608_rejection_signals: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="76" x2="195" y2="76" stroke="#16C784" strokeWidth="1.5" strokeDasharray="5,3" />
      <text x="193" y="73" fill="#16C784" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Support</text>

      <C x={20} o={55} c={48} h={44} l={80} w={14} />
      <text x="27" y="8" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Bounce</text>

      <C x={60} o={58} c={50} h={46} l={82} w={14} />
      <text x="67" y="8" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Again</text>

      <C x={100} o={54} c={46} h={42} l={80} w={14} />
      <text x="107" y="8" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Again</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Long lower wicks = buyers defending support</text>

    </svg>

  ),



  l6_c609_support_resistance_zones: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="25" width="190" height="12" rx="2" fill="#ef4444" opacity="0.15" />

      <text x="100" y="34" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Resistance Zone</text>

      <rect x="5" y="72" width="190" height="12" rx="2" fill="#16C784" opacity="0.15" />

      <text x="100" y="81" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Support Zone</text>

      <polyline points="10,85 30,72 50,80 70,72 90,78 110,55 130,32 150,26 165,32 180,22" fill="none" stroke="#94a3b8" strokeWidth="1.5" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Zones, not lines  -  price reacts within a range</text>

    </svg>

  ),



  l6_c610_volume_confirmation: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={20} o={65} c={55} h={52} l={67} w={12} />

      <rect x="20" y="90" width="12" height="8" fill="#94a3b8" opacity="0.5" />

      <C x={36} o={55} c={60} h={50} l={62} w={12} />

      <rect x="36" y="88" width="12" height="10" fill="#94a3b8" opacity="0.5" />

      <C x={52} o={60} c={52} h={49} l={62} w={12} />

      <rect x="52" y="89" width="12" height="9" fill="#94a3b8" opacity="0.5" />

      <C x={70} o={52} c={18} h={12} l={54} w={16} />

      <rect x="70" y="72" width="16" height="26" fill="#16C784" opacity="0.8" />

      <text x="78" y="68" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Vol spike</text>

      <text x="140" y="40" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Breakout</text>

      <text x="140" y="52" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">+ Volume OK</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">No volume = no conviction</text>

    </svg>

  ),



  l6_c611_strength_vs_weakness: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="11" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Strong</text>

      <C x={5}  o={82} c={62} h={58} l={84} w={14} />
      <C x={22} o={64} c={74} h={72} l={66} w={14} />
      <C x={39} o={74} c={52} h={48} l={76} w={14} />
      <C x={56} o={54} c={64} h={62} l={56} w={14} />
      <C x={73} o={64} c={38} h={34} l={66} w={14} />

      <text x="47" y="102" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Clean — tradeable</text>

      <text x="155" y="11" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Weak</text>

      <C x={110} o={54} c={44} h={36} l={68} w={14} />
      <C x={127} o={48} c={62} h={44} l={76} w={14} />
      <C x={144} o={60} c={48} h={38} l={72} w={14} />
      <C x={161} o={52} c={66} h={48} l={80} w={14} />

      <text x="155" y="102" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Choppy — avoid</text>

      <text x="100" y="108" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Clean trend = lower risk. Choppy = noise.</text>

    </svg>

  ),



  l6_c612_do_nothing_zones: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={5}   o={52} c={42} h={36} l={62} w={14} />
      <C x={22}  o={46} c={56} h={42} l={68} w={14} />
      <C x={39}  o={54} c={44} h={38} l={64} w={14} />
      <C x={56}  o={48} c={58} h={44} l={70} w={14} />
      <C x={73}  o={56} c={46} h={40} l={66} w={14} />
      <C x={90}  o={50} c={60} h={46} l={72} w={14} />
      <C x={107} o={54} c={44} h={38} l={64} w={14} />

      <line x1="145" y1="28" x2="165" y2="48" stroke="#ef4444" strokeWidth="3" strokeLinecap="round" />
      <line x1="165" y1="28" x2="145" y2="48" stroke="#ef4444" strokeWidth="3" strokeLinecap="round" />

      <text x="155" y="66" fill="#f59e0b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">No trade</text>
      <text x="155" y="78" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Wait for clear</text>
      <text x="155" y="88" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">direction</text>

      <text x="100" y="108" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Overlapping candles = no edge = wait</text>

    </svg>

  ),



  l6_c613_reversal_shift_in_control: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="5,90 22,75 40,58 55,42" fill="none" stroke="#16C784" strokeWidth="2" />
      <text x="8" y="100" fill="#16C784" fontSize="6" fontFamily="sans-serif">1. Uptrend</text>

      <polyline points="55,42 70,54 82,48" fill="none" stroke="#f59e0b" strokeWidth="2" />
      <text x="78" y="42" fill="#f59e0b" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Lower high</text>

      <line x1="40" y1="58" x2="195" y2="58" stroke="#ef4444" strokeWidth="1" strokeDasharray="3,2" />
      <text x="193" y="54" fill="#ef4444" fontSize="6" textAnchor="end" fontFamily="sans-serif">Low broken</text>

      <polyline points="82,48 98,62 118,76 140,86 165,93" fill="none" stroke="#ef4444" strokeWidth="2" />
      <text x="148" y="100" fill="#ef4444" fontSize="6" textAnchor="middle" fontFamily="sans-serif">3. Follow-through</text>

      <text x="100" y="108" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">3 steps confirm reversal — not 1 candle</text>

    </svg>

  ),



  // -- Level 7 ---------------------------------------------------------------



  l7_c702_event_second: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="15" width="88" height="55" rx="4" fill="#1e293b" stroke="#16C784" strokeWidth="1.5" />

      <text x="49" y="30" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Step 1: Trend</text>

      <text x="49" y="44" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Is price going up?</text>

      <text x="49" y="58" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">OK Uptrend confirmed</text>

      <rect x="107" y="15" width="88" height="55" rx="4" fill="#1e293b" stroke="#f59e0b" strokeWidth="1.5" />

      <text x="151" y="30" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Step 2: Event</text>

      <text x="151" y="44" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">What triggered signal?</text>

      <text x="151" y="58" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI + breakout</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Check trend FIRST  -  then the event</text>

    </svg>

  ),



  l7_c703_confirmation_third: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="12" width="56" height="48" rx="3" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="33" y="26" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">1. Trend OK</text>

      <text x="33" y="38" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Uptrend</text>

      <rect x="72" y="12" width="56" height="48" rx="3" fill="#1e293b" stroke="#f59e0b" strokeWidth="1" />

      <text x="100" y="26" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">2. Event OK</text>

      <text x="100" y="38" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Breakout</text>

      <rect x="139" y="12" width="56" height="48" rx="3" fill="#1e293b" stroke="#6366F1" strokeWidth="1" />

      <text x="167" y="26" fill="#6366F1" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">3. Confirm OK</text>

      <text x="167" y="38" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Volume spike</text>

      <text x="100" y="78" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">All 3 align -> enter</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Three filters = higher probability trade</text>

    </svg>

  ),



  l7_c704_no_confirmation: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="12" width="56" height="48" rx="3" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="33" y="26" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">1. Trend OK</text>

      <rect x="72" y="12" width="56" height="48" rx="3" fill="#1e293b" stroke="#f59e0b" strokeWidth="1" />

      <text x="100" y="26" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">2. Event OK</text>

      <rect x="139" y="12" width="56" height="48" rx="3" fill="#1e293b" stroke="#ef4444" strokeWidth="1.5" />

      <text x="167" y="26" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">3. Confirm X</text>

      <text x="167" y="38" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">No volume</text>

      <line x1="139" y1="12" x2="195" y2="60" stroke="#ef4444" strokeWidth="1.5" />

      <line x1="195" y1="12" x2="139" y2="60" stroke="#ef4444" strokeWidth="1.5" />

      <text x="100" y="78" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Skip the trade</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Missing one filter = don't trade</text>

    </svg>

  ),



  l7_c705_waiting_decision: (

    <svg viewBox="0 0 200 110" className="w-full">

      <circle cx="100" cy="48" r="32" fill="#1e293b" stroke="#334155" strokeWidth="1.5" />

      <text x="100" y="38" fill="#f59e0b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">No setup yet</text>

      <text x="100" y="52" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Trend unclear</text>

      <text x="100" y="64" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Wait.</text>

      <text x="30" y="98" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Waiting = discipline</text>

      <text x="160" y="98" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Forcing = mistake</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">No setup = no trade = best decision</text>

    </svg>

  ),



  l7_c706_risk_before_entry: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="18" width="180" height="52" rx="4" fill="#1e293b" stroke="#334155" strokeWidth="1" />

      <text x="100" y="34" fill="#f59e0b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Before entering, calculate:</text>

      <text x="100" y="48" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Max loss = ₹800 (2% of ₹40,000)</text>

      <text x="100" y="60" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Target = ₹2,400 (1:3 ratio)</text>

      <text x="100" y="72" fill="#6366F1" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Position size = ₹800 / (100-92) = 100 shares</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Calculate risk before placing the order</text>

    </svg>

  ),



  l7_c707_avoid_early_entry: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="45" x2="195" y2="45" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,3" />

      <C x={10} o={68} c={55} h={52} l={70} w={11} />

      <C x={24} o={55} c={62} h={48} l={64} w={11} />

      <C x={38} o={62} c={52} h={48} l={64} w={11} />

      <circle cx="55" cy="42" r="5" fill="#ef4444" />

      <text x="55" y="35" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Early entry</text>

      <C x={52} o={52} c={65} h={61} l={67} w={11} />

      <C x={66} o={65} c={72} h={68} l={74} w={11} />

      <text x="55" y="85" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Stopped out!</text>

      <C x={82} o={72} c={28} h={22} l={74} w={14} />

      <circle cx="95" cy="40" r="5" fill="#16C784" />

      <text x="140" y="30" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Wait for candle close</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Wait for candle to close above level</text>

    </svg>

  ),



  l7_c708_dont_chase_price: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,85 40,68 70,48 100,28 120,14" fill="none" stroke="#16C784" strokeWidth="2" />

      <circle cx="120" cy="14" r="5" fill="#16C784" />

      <text x="120" y="8" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Breakout here</text>

      <circle cx="165" cy="22" r="5" fill="#ef4444" />

      <text x="165" y="16" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">You buy here</text>

      <polyline points="120,14 145,18 165,22 180,35 190,55" fill="none" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="3,2" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Chasing price = buying at peak, selling at bottom</text>

    </svg>

  ),



  l7_c709_context_matters: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="11" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Same signal</text>

      <text x="50" y="22" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Uptrend context</text>

      <C x={15} o={65} c={38} h={34} l={67} w={16} />

      <text x="23" y="80" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">OK Valid entry</text>

      <text x="150" y="11" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Same signal</text>

      <text x="150" y="22" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Downtrend context</text>

      <C x={125} o={45} c={70} h={42} l={72} w={16} />

      <text x="133" y="80" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">X Avoid</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Same candle  -  different context = different decision</text>

    </svg>

  ),



  l7_c710_process_over_outcome: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="18" width="88" height="55" rx="4" fill="#1e293b" stroke="#16C784" strokeWidth="1.5" />

      <text x="49" y="32" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Good Process</text>

      <text x="49" y="46" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Followed all rules</text>

      <text x="49" y="58" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Trade lost</text>

      <text x="49" y="68" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">-> Still correct</text>

      <rect x="107" y="18" width="88" height="55" rx="4" fill="#1e293b" stroke="#ef4444" strokeWidth="1.5" />

      <text x="151" y="32" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Bad Process</text>

      <text x="151" y="46" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Broke all rules</text>

      <text x="151" y="58" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Trade won</text>

      <text x="151" y="68" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">-> Still wrong</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Judge your process  -  not just the outcome</text>

    </svg>

  ),



  // -- Level 9 ---------------------------------------------------------------



  l9_c906_macd: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="55" x2="195" y2="55" stroke="#334155" strokeWidth="1" />

      <polyline points="10,70 30,62 50,50 70,40 90,45 110,58 130,65 150,55 170,42 190,35" fill="none" stroke="#6366F1" strokeWidth="1.5" />

      <polyline points="10,75 30,68 50,58 70,50 90,52 110,60 130,67 150,60 170,50 190,44" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="4,2" />

      <text x="18" y="48" fill="#6366F1" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">MACD</text>

      <text x="18" y="60" fill="#f59e0b" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">Signal</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">MACD shows momentum direction and strength</text>

    </svg>

  ),



  l9_c907_macd_crossover: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="55" x2="195" y2="55" stroke="#334155" strokeWidth="1" />

      <polyline points="10,72 50,65 90,55 130,40 170,28" fill="none" stroke="#6366F1" strokeWidth="1.5" />

      <polyline points="10,80 50,72 90,62 130,52 170,45" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="4,2" />

      <circle cx="110" cy="47" r="5" fill="#16C784" />

      <text x="110" y="38" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Crossover = signal</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">MACD crosses above signal = bullish momentum</text>

    </svg>

  ),



  l9_c908_sma: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={8}  o={72} c={58} h={54} l={74} w={11} />

      <C x={22} o={58} c={65} h={52} l={67} w={11} />

      <C x={36} o={65} c={52} h={48} l={67} w={11} />

      <C x={50} o={52} c={60} h={47} l={62} w={11} />

      <C x={64} o={60} c={48} h={44} l={62} w={11} />

      <C x={78} o={48} c={38} h={34} l={50} w={11} />

      <C x={92} o={38} c={28} h={24} l={40} w={11} />

      <polyline points="13,65 27,62 41,60 55,57 69,55 83,52 97,48 111,44 125,40 139,36 153,32 167,28 181,24" fill="none" stroke="#f59e0b" strokeWidth="2" />

      <text x="170" y="20" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">SMA</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">SMA smooths price  -  shows average trend</text>

    </svg>

  ),



  l9_c909_price_above_sma: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,75 40,68 70,58 100,48 130,38 160,28 185,18" fill="none" stroke="#f59e0b" strokeWidth="2" strokeDasharray="5,2" />

      <text x="185" y="14" fill="#f59e0b" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">SMA 50</text>

      <C x={25} o={55} c={38} h={34} l={57} w={14} />

      <C x={55} o={40} c={25} h={21} l={42} w={14} />

      <C x={85} o={28} c={14} h={10} l={30} w={14} />

      <C x={115} o={16} c={8}  h={4}  l={18} w={14} />

      <text x="140" y="50" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Price above SMA</text>

      <text x="140" y="62" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">= Bullish bias</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Price above SMA = trend favors buyers</text>

    </svg>

  ),



  l9_c910_breakout_signals: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="48" x2="195" y2="48" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,3" />

      <C x={8}  o={70} c={57} h={53} l={72} w={11} />

      <C x={22} o={57} c={63} h={50} l={65} w={11} />

      <C x={36} o={63} c={55} h={51} l={65} w={11} />

      <C x={50} o={55} c={60} h={49} l={62} w={11} />

      <C x={66} o={60} c={18} h={12} l={62} w={14} />

      <rect x="90" y="55" width="12" height="30" fill="#16C784" opacity="0.6" />

      <rect x="106" y="62" width="12" height="23" fill="#16C784" opacity="0.4" />

      <text x="120" y="38" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Volume confirms</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Breakout + volume spike = valid signal</text>

    </svg>

  ),



  l9_c911_volume_spike: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="12" y="82" width="12" height="14" fill="#94a3b8" opacity="0.5" />

      <rect x="28" y="78" width="12" height="18" fill="#94a3b8" opacity="0.5" />

      <rect x="44" y="80" width="12" height="16" fill="#94a3b8" opacity="0.5" />

      <rect x="60" y="75" width="12" height="21" fill="#94a3b8" opacity="0.5" />

      <rect x="76" y="45" width="16" height="51" fill="#16C784" opacity="0.85" />

      <text x="84" y="40" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Spike!</text>

      <rect x="96" y="72" width="12" height="24" fill="#94a3b8" opacity="0.5" />

      <rect x="112" y="76" width="12" height="20" fill="#94a3b8" opacity="0.5" />

      <text x="155" y="45" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Volume spike =</text>

      <text x="155" y="57" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">big players moved</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Unusual volume = institutional activity</text>

    </svg>

  ),



  l9_c912_multi_signal_confluence: (

    <svg viewBox="0 0 200 110" className="w-full">

      <circle cx="70" cy="45" r="28" fill="#16C784" opacity="0.1" stroke="#16C784" strokeWidth="1" />

      <circle cx="100" cy="45" r="28" fill="#6366F1" opacity="0.1" stroke="#6366F1" strokeWidth="1" />

      <circle cx="85" cy="68" r="28" fill="#f59e0b" opacity="0.1" stroke="#f59e0b" strokeWidth="1" />

      <text x="50" y="32" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">RSI</text>

      <text x="120" y="32" fill="#6366F1" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">MACD</text>

      <text x="85" y="90" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Volume</text>

      <text x="85" y="52" fill="#fff" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">Edge</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Multiple signals agree = higher confidence</text>

    </svg>

  ),



  l9_c913_conflicting_signals: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="15" width="80" height="38" rx="3" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="50" y="30" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">RSI: Buy ^</text>

      <text x="50" y="44" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Oversold -> bounce</text>

      <rect x="110" y="15" width="80" height="38" rx="3" fill="#1e293b" stroke="#ef4444" strokeWidth="1" />

      <text x="150" y="30" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">MACD: Sell v</text>

      <text x="150" y="44" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Bearish cross</text>

      <text x="100" y="72" fill="#f59e0b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Conflict -> Skip</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Conflicting signals = no trade</text>

    </svg>

  ),



  l9_c914_scanner_timing_trap: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="30" y="12" width="140" height="32" rx="4" fill="#1e293b" stroke="#f59e0b" strokeWidth="1.5" />

      <text x="100" y="26" fill="#f59e0b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Scanner: BUY signal 9:20 AM</text>

      <text x="100" y="38" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Stock already up 4% at open</text>

      <line x1="100" y1="44" x2="100" y2="62" stroke="#ef4444" strokeWidth="1.5" />

      <polygon points="100,62 96,56 104,56" fill="#ef4444" />

      <text x="100" y="75" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">You chased -> bought at top</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Scanner fires late  -  check chart before acting</text>

    </svg>

  ),



  l9_c915_scanner_chart_decision: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="10" width="55" height="55" rx="3" fill="#1e293b" stroke="#f59e0b" strokeWidth="1.5" />

      <text x="32" y="26" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Scanner</text>

      <text x="32" y="38" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Finds</text>

      <text x="32" y="50" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Signal</text>

      <line x1="60" y1="37" x2="80" y2="37" stroke="#94a3b8" strokeWidth="1.5" />

      <polygon points="80,37 74,34 74,40" fill="#94a3b8" />

      <rect x="80" y="10" width="55" height="55" rx="3" fill="#1e293b" stroke="#6366F1" strokeWidth="1.5" />

      <text x="107" y="26" fill="#6366F1" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Chart</text>

      <text x="107" y="38" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Verify</text>

      <text x="107" y="50" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Context</text>

      <line x1="135" y1="37" x2="155" y2="37" stroke="#94a3b8" strokeWidth="1.5" />

      <polygon points="155,37 149,34 149,40" fill="#94a3b8" />

      <rect x="155" y="10" width="40" height="55" rx="3" fill="#16C784" opacity="0.15" stroke="#16C784" strokeWidth="1.5" />

      <text x="175" y="33" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Your</text>

      <text x="175" y="45" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Call</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Scanner -> Chart -> Your decision</text>

    </svg>

  ),



  // -- Level 11: AI ----------------------------------------------------------



  l11_c1106_ai_limitations: (

    <svg viewBox="0 0 200 110" className="w-full">

      <circle cx="100" cy="42" r="28" fill="#1e293b" stroke="#6366F1" strokeWidth="1.5" />

      <text x="100" y="36" fill="#6366F1" fontSize="9" textAnchor="middle" fontFamily="sans-serif">AI</text>

      <text x="100" y="50" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Pattern based</text>

      <line x1="72" y1="14" x2="58" y2="6" stroke="#ef4444" strokeWidth="1.5" />

      <text x="45" y="6" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">No emotion</text>

      <line x1="128" y1="14" x2="142" y2="6" stroke="#ef4444" strokeWidth="1.5" />

      <text x="158" y="6" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">No context</text>

      <line x1="100" y1="70" x2="100" y2="80" stroke="#ef4444" strokeWidth="1.5" />

      <text x="100" y="90" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Can't predict black swans</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">AI has limits  -  it works on patterns, not certainty</text>

    </svg>

  ),



  l11_c1107_ai_second_opinion: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="12" fill="#6366F1" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Your Analysis</text>

      <text x="50" y="30" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI oversold OK</text>

      <text x="50" y="42" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Uptrend OK</text>

      <text x="50" y="54" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Volume₹ unsure</text>

      <text x="150" y="12" fill="#6366F1" fontSize="8" textAnchor="middle" fontFamily="sans-serif">AI Check</text>

      <text x="150" y="30" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI oversold OK</text>

      <text x="150" y="42" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Uptrend OK</text>

      <text x="150" y="54" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Volume low X</text>

      <text x="100" y="76" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">-> Wait for volume</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">AI catches what you might miss</text>

    </svg>

  ),



  l11_c1108_ai_overconfidence_trap: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="25" y="12" width="150" height="32" rx="4" fill="#1e293b" stroke="#ef4444" strokeWidth="1.5" />

      <text x="100" y="26" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">"AI says BUY" -> You buy</text>

      <text x="100" y="38" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">No chart check. No risk calc.</text>

      <line x1="100" y1="44" x2="100" y2="60" stroke="#ef4444" strokeWidth="1.5" />

      <polygon points="100,60 96,54 104,54" fill="#ef4444" />

      <text x="100" y="74" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Stock drops 6%</text>

      <text x="100" y="86" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">No stop loss set. Big loss.</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Blind trust in AI = gambling, not trading</text>

    </svg>

  ),



  l11_c1109_ai_trade_feedback: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="10" width="190" height="62" rx="4" fill="#1e293b" stroke="#334155" strokeWidth="1" />

      <text x="100" y="24" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">After the trade  -  AI review:</text>

      <text x="100" y="38" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">OK Entry was valid  -  trend + signal aligned</text>

      <text x="100" y="50" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">X Stop loss was too tight  -  premature exit</text>

      <text x="100" y="62" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Next time: use ATR-based stop</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">AI feedback improves your process over time</text>

    </svg>

  ),



  l11_c1110_ai_questioning: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="30" y="10" width="140" height="30" rx="4" fill="#1e293b" stroke="#6366F1" strokeWidth="1" />

      <text x="100" y="29" fill="#6366F1" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">AI: "BUY signal on INFY"</text>

      <line x1="100" y1="40" x2="100" y2="55" stroke="#94a3b8" strokeWidth="1" />

      <text x="100" y="65" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">You: "Why? What's the trend?"</text>

      <text x="100" y="77" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">"What's the stop loss level?"</text>

      <text x="100" y="89" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">-> Now you understand the trade</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Ask AI why  -  don't just take the signal</text>

    </svg>

  ),



  l11_c1111_ai_as_tool: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="18" width="55" height="55" rx="3" fill="#1e293b" stroke="#6366F1" strokeWidth="1.5" />

      <text x="37" y="40" fill="#6366F1" fontSize="8" textAnchor="middle" fontFamily="sans-serif">AI</text>

      <text x="37" y="54" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Tool</text>

      <line x1="65" y1="45" x2="85" y2="45" stroke="#94a3b8" strokeWidth="1.5" />

      <polygon points="85,45 79,42 79,48" fill="#94a3b8" />

      <rect x="85" y="18" width="55" height="55" rx="3" fill="#1e293b" stroke="#16C784" strokeWidth="1.5" />

      <text x="112" y="40" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">You</text>

      <text x="112" y="54" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Decide</text>

      <line x1="140" y1="45" x2="160" y2="45" stroke="#94a3b8" strokeWidth="1.5" />

      <polygon points="160,45 154,42 154,48" fill="#94a3b8" />

      <rect x="160" y="18" width="35" height="55" rx="3" fill="#16C784" opacity="0.15" stroke="#16C784" strokeWidth="1.5" />

      <text x="177" y="40" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Trade</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">AI assists  -  you decide  -  always</text>

    </svg>

  ),



  l11_c1112_ai_correct_use: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="8" width="190" height="70" rx="4" fill="#1e293b" stroke="#334155" strokeWidth="1" />

      <text x="100" y="22" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Correct way to use AI:</text>

      <text x="18" y="36" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">OK Use for screening stocks</text>

      <text x="18" y="48" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">OK Use for pattern recognition</text>

      <text x="18" y="60" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">OK Use for post-trade review</text>

      <text x="18" y="72" fill="#ef4444" fontSize="7" textAnchor="start" fontFamily="sans-serif">X Never use as sole reason to trade</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">AI is a filter  -  your judgment is the final gate</text>

    </svg>

  ),



  // -- Level 4 (GPT renamed) -------------------------------------------------

  l4_c401_market_trends: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,85 50,60 90,35 130,20 170,10" fill="none" stroke="#16C784" strokeWidth="2.5" />

      <C x={30} o={72} c={48} h={44} l={74} w={14} />

      <C x={70} o={48} c={28} h={24} l={50} w={14} />

      <C x={110} o={28} c={14} h={10} l={30} w={14} />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Trade with the trend  -  not against it</text>

    </svg>

  ),

  l4_c402_volume_analysis: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="15" y="70" width="14" height="26" fill="#94a3b8" opacity="0.5" />

      <rect x="35" y="65" width="14" height="31" fill="#94a3b8" opacity="0.5" />

      <rect x="55" y="72" width="14" height="24" fill="#94a3b8" opacity="0.5" />

      <rect x="75" y="35" width="18" height="61" fill="#16C784" opacity="0.85" />

      <text x="84" y="30" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">^ Volume</text>

      <rect x="100" y="68" width="14" height="28" fill="#94a3b8" opacity="0.5" />

      <rect x="120" y="62" width="14" height="34" fill="#94a3b8" opacity="0.5" />

      <text x="155" y="50" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Volume confirms</text>

      <text x="155" y="62" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">price moves</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">High volume = conviction behind the move</text>

    </svg>

  ),



  // -- Level 6 (GPT renamed) -------------------------------------------------

  l6_c601_support_resistance: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="28" x2="195" y2="28" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="5,3" />

      <line x1="5" y1="78" x2="195" y2="78" stroke="#16C784" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="192" y="24" fill="#ef4444" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Resistance</text>

      <text x="192" y="74" fill="#16C784" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Support</text>

      <polyline points="10,80 30,65 50,78 70,55 90,78 110,42 130,28 150,35 170,28 185,18" fill="none" stroke="#94a3b8" strokeWidth="1.5" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Price bounces between support and resistance</text>

    </svg>

  ),

  l6_c602_candlestick_patterns: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={15} o={75} c={25} h={18} l={78} w={18} />

      <text x="24" y="104" fill="#16C784" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Marubozu</text>

      <C x={50} o={60} c={54} h={20} l={88} w={14} />

      <text x="57" y="104" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Doji</text>

      <C x={80} o={70} c={35} h={30} l={72} w={14} />

      <text x="87" y="104" fill="#16C784" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Hammer</text>

      <C x={112} o={55} c={28} h={24} l={57} w={18} />

      <C x={133} o={28} c={60} h={24} l={62} w={18} />

      <text x="142" y="104" fill="#16C784" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Engulfing</text>

      <text x="100" y="14" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Common candlestick patterns</text>

    </svg>

  ),



  // -- Level 8: Chart Patterns -----------------------------------------------

  l8_c801_pattern_is: (
    <svg viewBox="0 0 200 110" className="w-full">
      <line x1="5" y1="38" x2="195" y2="38" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="5,3" />
      <text x="193" y="34" fill="#ef4444" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">₹200 resistance</text>

      <C x={10} o={65} c={50} h={46} l={67} w={12} />
      <C x={25} o={50} c={58} h={44} l={60} w={12} />
      <C x={40} o={58} c={46} h={42} l={60} w={12} />

      <C x={58} o={46} c={32} h={26} l={48} w={14} />
      <text x="65" y="22" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Rejected</text>

      <C x={78} o={55} c={48} h={44} l={57} w={12} />
      <C x={93} o={48} c={56} h={42} l={58} w={12} />

      <C x={110} o={56} c={38} h={30} l={58} w={14} />
      <text x="117" y="26" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Rejected again</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Same reaction at same level = human behavior repeating</text>
    </svg>
  ),

  l8_c802_double_bottom: (
    <svg viewBox="0 0 200 110" className="w-full">
      <line x1="5" y1="75" x2="195" y2="75" stroke="#16C784" strokeWidth="1" strokeDasharray="4,3" />
      <text x="193" y="71" fill="#16C784" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Support</text>

      <polyline points="10,20 45,75 80,38 115,75 150,22" fill="none" stroke="#94a3b8" strokeWidth="2" />

      <circle cx="45" cy="75" r="4" fill="#16C784" />
      <text x="45" y="90" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Bottom 1</text>

      <circle cx="115" cy="75" r="4" fill="#16C784" />
      <text x="115" y="90" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Bottom 2</text>

      <circle cx="80" cy="38" r="4" fill="#f59e0b" />
      <text x="80" y="32" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Neckline</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">W shape — buyers defend support twice</text>
    </svg>
  ),

  l8_c803_double_top: (
    <svg viewBox="0 0 200 110" className="w-full">
      <line x1="5" y1="28" x2="195" y2="28" stroke="#ef4444" strokeWidth="1" strokeDasharray="4,3" />
      <text x="193" y="24" fill="#ef4444" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Resistance</text>

      <polyline points="10,90 45,28 80,65 115,28 150,88" fill="none" stroke="#94a3b8" strokeWidth="2" />

      <circle cx="45" cy="28" r="4" fill="#ef4444" />
      <text x="45" y="20" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Top 1</text>

      <circle cx="115" cy="28" r="4" fill="#ef4444" />
      <text x="115" y="20" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Top 2</text>

      <circle cx="80" cy="65" r="4" fill="#f59e0b" />
      <text x="80" y="78" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Neckline</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">M shape — sellers reject price twice</text>
    </svg>
  ),

  l8_c804_head_shoulders: (
    <svg viewBox="0 0 200 110" className="w-full">
      <polyline points="5,85 30,55 55,85 90,22 125,85 150,45 175,85" fill="none" stroke="#94a3b8" strokeWidth="2" />

      <circle cx="30" cy="55" r="4" fill="#f59e0b" />
      <text x="30" y="48" fill="#f59e0b" fontSize="6" textAnchor="middle" fontFamily="sans-serif">L.Shoulder</text>

      <circle cx="90" cy="22" r="4" fill="#ef4444" />
      <text x="90" y="15" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Head</text>

      <circle cx="150" cy="45" r="4" fill="#f59e0b" />
      <text x="150" y="38" fill="#f59e0b" fontSize="6" textAnchor="middle" fontFamily="sans-serif">R.Shoulder</text>

      <line x1="5" y1="85" x2="195" y2="85" stroke="#ef4444" strokeWidth="1" strokeDasharray="4,3" />
      <text x="192" y="82" fill="#ef4444" fontSize="6" textAnchor="end" fontFamily="sans-serif">Neckline</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Each high is lower — buying strength fading</text>
    </svg>
  ),

  l8_c805_inv_head_shoulders: (
    <svg viewBox="0 0 200 110" className="w-full">
      <polyline points="5,22 30,55 55,22 90,85 125,22 150,62 175,22" fill="none" stroke="#94a3b8" strokeWidth="2" />

      <circle cx="30" cy="55" r="4" fill="#f59e0b" />
      <text x="30" y="65" fill="#f59e0b" fontSize="6" textAnchor="middle" fontFamily="sans-serif">L.Shoulder</text>

      <circle cx="90" cy="85" r="4" fill="#16C784" />
      <text x="90" y="97" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Head</text>

      <circle cx="150" cy="62" r="4" fill="#f59e0b" />
      <text x="150" y="72" fill="#f59e0b" fontSize="6" textAnchor="middle" fontFamily="sans-serif">R.Shoulder</text>

      <line x1="5" y1="22" x2="195" y2="22" stroke="#16C784" strokeWidth="1" strokeDasharray="4,3" />
      <text x="192" y="18" fill="#16C784" fontSize="6" textAnchor="end" fontFamily="sans-serif">Neckline</text>

      <text x="100" y="108" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Each low is higher — selling pressure fading</text>
    </svg>
  ),

  l8_c806_asc_triangle: (
    <svg viewBox="0 0 200 110" className="w-full">
      <line x1="5" y1="28" x2="155" y2="28" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="5,3" />
      <text x="153" y="24" fill="#ef4444" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Flat resistance</text>

      <polyline points="5,88 155,42" fill="none" stroke="#16C784" strokeWidth="1.5" strokeDasharray="5,3" />
      <text x="40" y="100" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Rising support</text>

      <C x={8}  o={82} c={70} h={66} l={84} w={11} />
      <C x={22} o={70} c={60} h={56} l={72} w={11} />
      <C x={36} o={60} c={52} h={46} l={62} w={11} />
      <C x={50} o={52} c={44} h={38} l={54} w={11} />
      <C x={66} o={44} c={20} h={14} l={46} w={14} />

      <text x="80" y="10" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Breakout!</text>
      <polygon points="80,13 77,18 83,18" fill="#16C784" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Rising lows + flat resistance = buyers winning</text>
    </svg>
  ),

  l8_c807_desc_triangle: (
    <svg viewBox="0 0 200 110" className="w-full">
      <line x1="5" y1="80" x2="155" y2="80" stroke="#16C784" strokeWidth="1.5" strokeDasharray="5,3" />
      <text x="153" y="76" fill="#16C784" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Flat support</text>

      <polyline points="5,22 155,62" fill="none" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="5,3" />
      <text x="50" y="18" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Falling resistance</text>

      <C x={8}  o={28} c={38} h={24} l={82} w={11} />
      <C x={22} o={38} c={48} h={34} l={82} w={11} />
      <C x={36} o={48} c={58} h={44} l={82} w={11} />
      <C x={50} o={58} c={66} h={52} l={82} w={11} />
      <C x={66} o={66} c={98} h={84} l={100} w={14} />

      <text x="80" y="105" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Breakdown!</text>

      <text x="100" y="108" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Falling highs + flat support = sellers winning</text>
    </svg>
  ),

  l8_c808_bull_flag: (
    <svg viewBox="0 0 200 110" className="w-full">
      <polyline points="5,90 35,40" fill="none" stroke="#16C784" strokeWidth="2.5" />
      <text x="20" y="100" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Pole</text>

      <C x={38} o={42} c={50} h={38} l={52} w={10} />
      <C x={51} o={50} c={56} h={47} l={58} w={10} />
      <C x={64} o={56} c={62} h={52} l={64} w={10} />
      <C x={77} o={62} c={68} h={58} l={70} w={10} />
      <text x="65" y="15" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Flag (pause)</text>

      <polyline points="90,65 120,35 155,12 185,5" fill="none" stroke="#16C784" strokeWidth="2.5" />
      <text x="155" y="24" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Continuation</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Strong move → small dip → resumes higher</text>
    </svg>
  ),

  l8_c809_bear_flag: (
    <svg viewBox="0 0 200 110" className="w-full">
      <polyline points="5,15 35,65" fill="none" stroke="#ef4444" strokeWidth="2.5" />
      <text x="20" y="12" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Pole</text>

      <C x={38} o={62} c={54} h={56} l={64} w={10} />
      <C x={51} o={54} c={48} h={50} l={56} w={10} />
      <C x={64} o={48} c={42} h={44} l={50} w={10} />
      <C x={77} o={42} c={36} h={38} l={44} w={10} />
      <text x="65" y="28" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Flag (pause)</text>

      <polyline points="90,38 120,65 155,85 185,100" fill="none" stroke="#ef4444" strokeWidth="2.5" />
      <text x="155" y="80" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Continuation</text>

      <text x="100" y="108" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Sharp drop → small bounce → resumes lower</text>
    </svg>
  ),

  l8_c810_support_bounce: (
    <svg viewBox="0 0 200 110" className="w-full">
      <line x1="5" y1="78" x2="195" y2="78" stroke="#16C784" strokeWidth="1.5" strokeDasharray="5,3" />
      <text x="193" y="74" fill="#16C784" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Support ₹100</text>

      <polyline points="10,30 30,78 50,45 70,78 90,48 118,78 145,95 175,100" fill="none" stroke="#94a3b8" strokeWidth="1.5" />

      <circle cx="30" cy="78" r="4" fill="#16C784" />
      <text x="30" y="92" fill="#16C784" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Bounce</text>

      <circle cx="70" cy="78" r="4" fill="#16C784" />
      <text x="70" y="92" fill="#16C784" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Bounce</text>

      <circle cx="118" cy="78" r="4" fill="#ef4444" />
      <text x="125" y="68" fill="#ef4444" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Breaks!</text>

      <text x="100" y="108" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Support holds — until buyers are exhausted</text>
    </svg>
  ),

  l8_c811_resistance_reject: (
    <svg viewBox="0 0 200 110" className="w-full">
      <line x1="5" y1="28" x2="195" y2="28" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="5,3" />
      <text x="193" y="24" fill="#ef4444" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Resistance ₹250</text>

      <polyline points="10,88 30,28 50,55 70,28 90,62 115,28 145,48 175,72" fill="none" stroke="#94a3b8" strokeWidth="1.5" />

      <circle cx="30" cy="28" r="4" fill="#ef4444" />
      <text x="30" y="18" fill="#ef4444" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Rejected</text>

      <circle cx="70" cy="28" r="4" fill="#ef4444" />
      <text x="70" y="18" fill="#ef4444" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Rejected</text>

      <circle cx="115" cy="28" r="4" fill="#ef4444" />
      <text x="115" y="18" fill="#ef4444" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Sharp fall</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Each rejection builds selling pressure</text>
    </svg>
  ),

  l8_c812_patterns_fail: (
    <svg viewBox="0 0 200 110" className="w-full">
      <Div />

      <text x="50" y="11" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Pattern only</text>

      <line x1="5" y1="68" x2="95" y2="68" stroke="#16C784" strokeWidth="1" strokeDasharray="3,2" />
      <polyline points="10,30 30,68 50,45 70,68 85,22" fill="none" stroke="#94a3b8" strokeWidth="1.5" />
      <circle cx="30" cy="68" r="3" fill="#16C784" />
      <circle cx="70" cy="68" r="3" fill="#16C784" />
      <text x="50" y="82" fill="#16C784" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Double bottom</text>
      <text x="50" y="91" fill="#ef4444" fontSize="6" textAnchor="middle" fontFamily="sans-serif">You buy ^</text>

      <text x="150" y="11" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Context</text>

      <polyline points="108,18 125,28 145,24 165,38 185,32" fill="none" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="3,2" />
      <text x="150" y="50" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Overall downtrend</text>
      <polyline points="108,55 130,65 155,75 180,90" fill="none" stroke="#ef4444" strokeWidth="1.5" />
      <text x="150" y="103" fill="#ef4444" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Price breaks lower</text>

      <text x="100" y="108" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif" opacity="0">x</text>
    </svg>
  ),



  // -- Level 9/10 (GPT renamed) ----------------------------------------------

  l9_c901_swing_trading: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,85 35,60 60,72 85,40 110,55 135,25 160,38 185,15" fill="none" stroke="#16C784" strokeWidth="2" />

      <circle cx="35" cy="60" r="4" fill="#16C784" />

      <text x="35" y="54" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Buy</text>

      <circle cx="85" cy="40" r="4" fill="#ef4444" />

      <text x="85" y="34" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Sell</text>

      <circle cx="110" cy="55" r="4" fill="#16C784" />

      <text x="110" y="49" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Buy</text>

      <circle cx="160" cy="38" r="4" fill="#ef4444" />

      <text x="160" y="32" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Sell</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Swing trading = capture moves over days/weeks</text>

    </svg>

  ),

  l9_c902_day_trading: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="8" width="190" height="18" rx="3" fill="#1e293b" stroke="#334155" strokeWidth="1" />

      <text x="60" y="20" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">9:15 AM Open</text>

      <text x="140" y="20" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">3:30 PM Close</text>

      <C x={10}  o={65} c={45} h={40} l={68} w={11} />

      <C x={24}  o={45} c={55} h={40} l={58} w={11} />

      <C x={38}  o={55} c={38} h={34} l={58} w={11} />

      <C x={52}  o={38} c={48} h={34} l={50} w={11} />

      <C x={66}  o={48} c={32} h={28} l={50} w={11} />

      <C x={80}  o={32} c={42} h={28} l={44} w={11} />

      <C x={94}  o={42} c={28} h={24} l={44} w={11} />

      <C x={108} o={28} c={38} h={24} l={40} w={11} />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">All positions closed by market end  -  no overnight</text>

    </svg>

  ),

  l10_c1001_options_trading: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="20" y="12" width="160" height="60" rx="4" fill="#1e293b" stroke="#f59e0b" strokeWidth="1.5" />

      <text x="100" y="26" fill="#f59e0b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Options Contract</text>

      <text x="100" y="40" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">CE (Call) = right to BUY at strike</text>

      <text x="100" y="52" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">PE (Put) = right to SELL at strike</text>

      <text x="100" y="64" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Pay premium. Risk = premium only.</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Options = right without obligation</text>

    </svg>

  ),

  l10_c1002_futures_trading: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="20" y="12" width="160" height="60" rx="4" fill="#1e293b" stroke="#ef4444" strokeWidth="1.5" />

      <text x="100" y="26" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Futures Contract</text>

      <text x="100" y="40" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Obligation to buy/sell at expiry</text>

      <text x="100" y="52" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Leverage: small margin controls big lot</text>

      <text x="100" y="64" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Losses can exceed your margin</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Futures = obligation + leverage + higher risk</text>

    </svg>

  ),



  // -- Level 11 (GPT renamed) ------------------------------------------------

  l11_c1101_advanced_indicators: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,60 30,52 50,58 70,42 90,48 110,35 130,40 150,28 170,32 190,20" fill="none" stroke="#6366F1" strokeWidth="1.5" />

      <polyline points="10,65 30,60 50,63 70,52 90,55 110,46 130,50 150,40 170,43 190,34" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="4,2" />

      <polyline points="10,70 30,66 50,68 70,60 90,62 110,55 130,58 150,50 170,53 190,45" fill="none" stroke="#16C784" strokeWidth="1.5" strokeDasharray="2,2" />

      <text x="18" y="44" fill="#6366F1" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">VWAP</text>

      <text x="18" y="54" fill="#f59e0b" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">ATR</text>

      <text x="18" y="64" fill="#16C784" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">Supertrend</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Advanced indicators add context  -  not certainty</text>

    </svg>

  ),

  l11_c1102_algo_trading: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="18" width="55" height="50" rx="3" fill="#1e293b" stroke="#6366F1" strokeWidth="1.5" />

      <text x="37" y="36" fill="#6366F1" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Rules</text>

      <text x="37" y="48" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">IF RSI &lt; 30</text>

      <text x="37" y="58" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">AND vol &gt; avg</text>

      <text x="37" y="68" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">-> BUY</text>

      <line x1="65" y1="43" x2="85" y2="43" stroke="#94a3b8" strokeWidth="1.5" />

      <polygon points="85,43 79,40 79,46" fill="#94a3b8" />

      <rect x="85" y="18" width="55" height="50" rx="3" fill="#1e293b" stroke="#16C784" strokeWidth="1.5" />

      <text x="112" y="36" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Engine</text>

      <text x="112" y="50" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Scans 200</text>

      <text x="112" y="62" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">stocks/min</text>

      <line x1="140" y1="43" x2="160" y2="43" stroke="#94a3b8" strokeWidth="1.5" />

      <polygon points="160,43 154,40 154,46" fill="#94a3b8" />

      <rect x="160" y="28" width="32" height="30" rx="3" fill="#16C784" opacity="0.15" stroke="#16C784" strokeWidth="1" />

      <text x="176" y="42" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Order</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Algo executes rules  -  you define the rules</text>

    </svg>

  ),



};


